import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {environment} from 'src/environments/environment';
import {
  Back,
  ChangeTransferEMployerDocument,
  City,
  ConfigCard,
  DaneCity,
  EmployerChangeDocument,
  ModelDocumentsShow,
  SecurityReference
} from 'src/app/core/interfaces/interfaces';
import {CommonOptions} from '../../../interfaces/interfaces';
import {CommonService} from '../../../services/modules/common.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NumberCountry} from '../../../constants/number-city.constant';
import {FechasService} from '../../../services/utils/fechas.service';
import {PersonalService} from '../../../services/modules/personal.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PersonalContractProyect, ProjectContracts} from '../../../models/Personal/PersonalContractProyect';
import {InfoPersonalCompanyPersonalId} from '../../../models/Personal/InfoPersonalCompanyPersonalId';
import {FaceValidation} from '../../../models/Personal/FaceTrace';
import {SnackBarService} from '../../../services/utils/snackBar.service';
import {DialogService} from '../../../services/utils/dialog.service';
import {DialogChangeWorkplaceResult} from '../../dialogs/dialog-change-workplace/dialog-change-workplace.component';
import {
  Certification,
  ContractsOffline,
  Entry,
  putEmployerPersonalRequirement,
  ReplaceEPSorAFP,
  SocialSecurity,
  Surveys
} from 'src/app/core/models/Personal/ContractsOffline';
import {EmployerService} from 'src/app/core/services/modules/employer.service';
import {TypeSecurityReference} from 'src/app/core/constants/type-security-references';
import {ContratingService} from 'src/app/core/services/modules/contrating.service';
import {PersonalInfoContract} from 'src/app/core/models/Personal/personalInfoContract';
import {CommonMetodService} from 'src/app/core/services/utils/commonMetod.service';
import {User} from 'src/app/core/models/User';
import {AuthService} from 'src/app/core/services/modules/auth.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ContractService} from 'src/app/core/services/modules/contract.service';
import {CurrencyPipe} from '@angular/common';
import {Positions} from 'src/app/core/models/IndividualContract/interfacesIndividualContract';
import {RequestService} from '../../../services/modules/request.service';
import {DialogDataConfirm} from 'src/app/modules/employer/components/planilla/planilla.component';
import {ProjectService} from 'src/app/core/services/modules/project.service';
import {TerminationService} from 'src/app/core/services/modules/termination-service';
import {CompaniesService} from 'src/app/core/services/modules/companies.service';
import {catchError, take} from 'rxjs/operators';
import {forkJoin, of} from 'rxjs';
import {BlacklistResponse} from './models/interfaces';

@Component({
  selector: 'cards-personal',
  templateUrl: './cards-personal.component.html',
  styleUrls: ['./cards-personal.component.scss']
})
export class CardsPersonalComponent implements OnInit {
  maxDate: any;
  userAuth: User;
  s3Bucket: string;
  flagVetoInfo: any;
  personalId: number;
  flagListFInfo: any;
  restPersonalCV: any;
  ccfName: string = null;
  contractLaborSelected: any;
  flagBlackListFuture: boolean;
  personalCompanyInfoId: string;
  formDataStudyCertificate: any;
  flagBlackListFutureVeto: boolean;
  formDataExperienceCertificate: any;
  urlDataStudyCertificate: any = null;
  EmployerInfoId: string | null = null;
  SubContractorId: string | null = null;
  urlDataExperienceCertificate: any = null;
  exitPersonalEmployerByPersonalPOSTPUT: boolean;

  configCard: ConfigCard;
  formVaccine: FormGroup;
  formPersonal: FormGroup;
  formVigencia: FormGroup;
  formEmpleador: FormGroup;
  formPersonalCV: FormGroup;
  formOtrosDatos: FormGroup;
  formDatosContrato: FormGroup;
  production = environment;
  formVigenciaArlExigida: FormGroup;
  contractSelected: ContractsOffline;
  personalInfo: PersonalInfoContract;
  personal: InfoPersonalCompanyPersonalId;
  employerChangeDocument: EmployerChangeDocument;
  personalContractProyectSelected: PersonalContractProyect;
  infoPersonalCompanyPersonalId: InfoPersonalCompanyPersonalId;
  isPhotoQualityFailed: boolean = false;

  controEps = new FormControl();
  controAfp = new FormControl();
  controlCCF = new FormControl();
  controHistory = new FormControl();
  controOccupationalRisk = new FormControl();
  controlExpeditionDate = new FormControl();
  controlExpeditionPlace = new FormControl();

  history: [] = [];
  bancks: Back[] = [];
  entry: Entry[] = [];
  surveys: Surveys[] = [];
  rh: CommonOptions[] = [];
  daneCity: DaneCity[] = [];
  sex: CommonOptions[] = [];
  states: CommonOptions[] = [];
  afp: SecurityReference[] = [];
  eps: SecurityReference[] = [];
  ccf: any[] = [];
  citiesNacimiento: City[] = [];
  citiesExpedicion: City[] = [];
  countrys: CommonOptions[] = [];
  dateLabel: CommonOptions[] = [];
  lastStages: CommonOptions[] = [];
  nationality: CommonOptions[] = [];
  vaccineType: CommonOptions[] = [];
  contracts: ContractsOffline[] = [];
  filesStudyCertificate: File[] = [];
  maritalStatus: CommonOptions[] = [];
  socialStratum: CommonOptions[] = [];
  certification: Certification[] = [];
  bankAccountType: CommonOptions[] = [];
  socialSecurity: SocialSecurity[] = [];
  educationalLevel: CommonOptions[] = [];
  occupationalRisk: CommonOptions[] = [];
  filesExperienceCertificate: File[] = [];
  vaccinationStatus: CommonOptions[] = [];
  companyDocumentType: CommonOptions[] = [];
  compareDocumentType = (val1: any, val2: any): boolean => {
    if (val1 == null || val2 == null) {
      return val1 === val2;
    }
    return String(val1).trim().toUpperCase() === String(val2).trim().toUpperCase();
  };

  filterCompanyDocumentTypes(options: CommonOptions[], nationality: string | number, currentDocType?: string): CommonOptions[] {
    if (!Array.isArray(options) || options.length === 0) {
      if (currentDocType) {
        const val = String(currentDocType).trim();
        return [{
          Description: val,
          Value: val,
          Id: 0,
          IsActive: true,
          OrderNum: 0,
          File: '',
          Type: 'CompanyDocumentType'
        }];
      }
      return [];
    }

    const nat = String(nationality ?? '').trim();
    let filtered: CommonOptions[];

    if (nat === '0') {
      filtered = options.filter(x => x.Value === 'CC' || x.Value === 'TI');
      if (!filtered.length) {
        filtered = options.filter(x => x.Value === 'CC');
      }
    } else if (nat !== '') {
      filtered = options.filter(x => ['PE', 'PEP', 'CE', 'PPT', 'PAS', 'PA'].includes(x.Value));
      if (!filtered.length) {
        filtered = options.filter(x => x.Value === 'PE' || x.Value === 'CE' || x.Value === 'PPT');
      }
    } else {
      filtered = options.filter(x => ['CC', 'TI', 'CE', 'PE', 'PEP', 'PPT', 'PAS', 'PA'].includes(x.Value));
      if (!filtered.length) {
        filtered = [...options];
      }
    }

    if (currentDocType) {
      const trimmedDoc = String(currentDocType).trim().toUpperCase();
      const exists = filtered.some(x => String(x.Value ?? '').trim().toUpperCase() === trimmedDoc);
      if (!exists) {
        const fromCatalog = options.find(x => String(x.Value ?? '').trim().toUpperCase() === trimmedDoc);
        if (fromCatalog) {
          filtered.push(fromCatalog);
        } else {
          filtered.push({
            Description: String(currentDocType).trim(),
            Value: String(currentDocType).trim(),
            Id: 0,
            IsActive: true,
            OrderNum: 0,
            File: '',
            Type: 'CompanyDocumentType'
          });
        }
      }
    }

    return filtered.sort((a, b) => (a.OrderNum != null ? a.OrderNum : Infinity) - (b.OrderNum != null ? b.OrderNum : Infinity));
  }

  contractsOffline: ContractsOffline[] = [];
  replaceEPSorAFPdata: ReplaceEPSorAFP[] = [];
  individualContractsType: CommonOptions[] = [];
  positionsIndividualContract: Positions[] = [];
  personalContractProyect: PersonalContractProyect[] = [];
  dateSocialSecurityUpload: putEmployerPersonalRequirement[] = [];
  docsUploadIniadoSocialSecurity: putEmployerPersonalRequirement[] = [];

  jobs: any = [];
  town: any[] = [];
  positions: any = [];
  projects: any[] = [];
  workShift: any[] = [];
  trainings: any[] = [];
  allEmployers: any[] = [];
  contractsLabor: any[] = [];
  permissions: string[] = [];
  sortedTrainings: any[] = [];
  securityReferences: any = [];
  positionSujester: string[] = [];
  permissionsCompany: string[] = [];
  personalContractPosition: any[] = [];
  visibleLaborContractsSorted: any[] = [];

  min = 0;
  max = 0;
  indexSelect = 0;
  indexSelectContracLabor = 0;

  isActive: boolean;
  hasDocuments: boolean;
  flagVeto = false;
  edadRange = false;
  flagListF = false;
  IsValidedARL = false;
  showOnlyActive = true;
  hasAnyContracts = false;
  btn_menuHistory = false;
  changeEmployerId = false;
  requestPhotoChange = false;
  hasActiveContracts = false;
  showOnlyActiveLabor = true;
  isCreateAppPersonal = false;
  exitContractsOffline = false;
  flagChangeContratista = false;
  flagChangeCCFPersonal = false;
  hasAnyActiveContracts = false;
  sanctionedByExtraTime = false;
  showOnlyInactiveBanner = false;
  isLoadingLaborContracts = false;
  disabledByPermissionUpdate = false;

  email = '';
  employerName = '';
  employerId = '';
  personalStatus = '';
  biometricMaxMin = '';
  companyIdUserLogin = '';
  IsSuperUser = false;

  // Variables para primer paso de change in formularios
  flagChangeDataBtnSave = false;
  changeAfterfillFormPersonal = true;
  changeAfterfillFormVaccine = false;
  changeAfterfillFormVigencia = false;
  changeAfterfillFormPersonalCV = false;
  changeAfterfillFormOtrosDatos = false;
  changeAfterfillFormVigenciaArlExigida = false;
  changeAfterfillFormContractIndividual = false;

  date = new Date();
  minDateVigenciaContract = this.fechasService.getDateNow();
  minDateSocialSecurity = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());
  maxDateSocialSecurity = new Date(this.date.getFullYear(), this.date.getMonth() , this.date.getDate() + 60);

  allContractsActiveInactive: ContractsOffline[] = [];

  HasExtraTimeList: any[] = [
    {value: true, name: 'SI'},
    {value: false, name: 'NO'},
  ];

  hasExtraTimeChangeSnapshot: { index: number; previousValue: any } | null = null;
  projectChangeSnapshot: { index: number; previousProjectId: any; previousWorkShiftId: any; previousWorkShiftList: any } | null = null;

  listMenuHistory = [
    { name: 'VINCULADOS A LOS CONTRATOS Y PROYECTOS', id: 1}
  ];

  arrayDOSIS = [{value: 1, name: 'PRIMERA'},
    {value: 2, name: 'SEGUNDA'},
    {value: 3, name: 'TERCERA'}
  ];

  expansionConfig: any[] = [
    {name: 'vincProjecContrac', value: true},
  ];


  @ViewChild('pickerSocialAFP') pickerSocialAFP: any;

  @Input() set eventButon(value: any) {
    if (value !== undefined) {
      this.eventSave();
    }
  }

  @Input() set _configCard(value: ConfigCard) {
    this.configCard = value;
    if (value.typeCard === 'information') {
      this.getIndividualContractsType();
      this.personalId = value.Id;
      this.getPersonalContracts();
      this.getServicesPersonalCV();

      this.getContractPersonal();
      this.getServices();
      this.getVaccine(value.Id);
      this.servicesPersonal();

      this.controHistory.setValue(1);
    }
  }

  @Input() set _permissions(value: string[]) {
    if (value.length > 0) {
      this.permissions = value;
    }
  }

  private readonly EXPIRY_WARNING_DAYS = 7;
  private onlyInactivesMode = false;
  private deferLaborResort = false;
  contractsAll: ContractsOffline[] = [];
  private filterContracts: ContractsOffline[] = [];
  private totalContractsCount: number | null = null;
  private inactiveContractsLoaded = false;
  trackByContractId = (_: number, item: any) => item?.Id ?? item?.ContractNumber ?? _;

  constructor(
    private commonService: CommonService,
    private fb: FormBuilder,
    public fechasService: FechasService,
    private personalService: PersonalService,
    private ar: ActivatedRoute,
    private snackBService: SnackBarService,
    private dialogService: DialogService,
    private employerService: EmployerService,
    private commonServices: CommonService,
    private contratingService: ContratingService,
    public commonMetodService: CommonMetodService,
    private authService: AuthService,
    private contractService: ContractService,
    private router: Router,
    private currencyPipe: CurrencyPipe,
    private requestService: RequestService,
    private projectService: ProjectService,
    private terminationService: TerminationService,
    private companiesService: CompaniesService,
    private dialog: MatDialog,
  ) {
    this.s3Bucket = environment.api.s3Bucket;
    this.ar.params.subscribe((parametros) => {
      this.personalCompanyInfoId = parametros.Id;
    });
    this.userAuth = this.authService.getUser();
    this.IsSuperUser = this.userAuth?.IsSuperUser ?? false;
    this.email = this.userAuth?.Email !== null && this.userAuth?.Email !== undefined ? this.userAuth?.Email : '';
    const capital = this.userAuth?.Companies.find(x => x.Id === 'f3dfc3f6-7da3-423b-bb55-5631f6517d31' || x.Id === 'f783fe09-bf7a-497b-a3f2-ce4e20969d2e');
    if (capital !== undefined) {this.companyIdUserLogin = capital.Id; }
    this.formPersonal = this.fb.group({
      Nationality: new FormControl('', Validators.required),
      DocumentNumber: new FormControl(''),
      DocumentType: new FormControl(''),
      Name: new FormControl('', Validators.required),
      LastName: new FormControl('', Validators.required),
      BirthDate: new FormControl('', [Validators.required, Validators.minLength(8)]),
      Sex: new FormControl('', Validators.required),
      RH: new FormControl('', Validators.required),
      contryNalcionality: new FormControl('', Validators.required),
      CityCode: '',
      CityOfBirthCode: new FormControl('', Validators.required),
      EmergencyContact: new FormControl(''),
      EmergencyContactPhone: new FormControl(''),
      RelationshipWithContact: new FormControl(''),
      Address: '',
      PhoneNumber: '',
      TownId: '',
      Email: new FormControl('', [Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      Photo: '',
      EpsId: '',
      AfpId: '',
      CCFId: '',
      // Datos de hoja de vida
      JobCode: ''
    });
    this.formVigencia = this.fb.group({
      StartDateContract: '',
      FinishDateContract: '',
      Position: '',
      EmployerName: '',
      EmployerItemId: '',
      EmployerId: '',
      EmployerLogo: '',
      ContractReview: '',
      DescriptionPersonalType: '',
      EmployerDocumentType: '',
      EmployerDocumentNumber: '',
      CompanyInfoParentId: '',
      IsActive: '',
      HasDocuments: '',
      // Seach Cambiar empleador
      SearchEmpleador: ''
    });
    this.formVigenciaArlExigida = this.fb.group({
      TypeARL: ''
    });
    this.formEmpleador = this.fb.group({
      employer: new FormControl({ value: null, disabled: true })
    });
    this.formPersonalCV = this.fb.group({
      PersonalCompanyInfoId: '',
      EducationalLevelId: '',
      ExperienceYears: 0,
      ExperienceMonths: 0,
      JobCode: '',
      MaritalStatusId: '',
      NumberOfChilds: 0,
      NumberOfDependants: 0,
      SocialStratumId: '',
      Medicines: ''
    });
    this.formVaccine = this.fb.group({
      VaccineStatusId: 0,
      PersonalCompanyInfoId: 0,
      VaccineTypeId: 0,
      AppliedDose: 0,
      VaccineObservations: ''
    });
    this.formDatosContrato = this.fb.group({
      IndividualContractTypeId: new FormControl(''),
      PersonalEmployerInfoId: new FormControl(''),
      PositionName: new FormControl(''),
      Salary:  ['', Validators.min(1)],
      AuxiliaryTransport:  ['', Validators.min(1)],
      TotalEarnings: ['', Validators.min(1)],
      PayPeriodId: new FormControl(''),
      StartDate: ['', Validators.required],
      EndDate: ['', Validators.required],
      contry: new FormControl('0'),
      ProjectId: new FormControl(''),
      ContractCityId: new FormControl(''),
      ContractId: '',
      examType: '',
      EmployerInfoId: '',
      EmployerName: '',
      EmployerDocumentType: '',
      EmployerDocumentNumber: '',
      EmployerLogo: '',
      // Datos bancarios
      BankAccount: '',
      BankId: '',
      BankAccountTypeId: '',
      ContractNumber: '',
      ContractTypeId: '',
      // Datos Prenomina
      WorkShiftId: '',
      HasExtraTime: ''
    });
    this.formOtrosDatos = this.fb.group({
      BankAccount: new FormControl('', Validators.required),
      BankId: new FormControl('', Validators.required),
      BankAccountTypeId: new FormControl('', Validators.required)
    });
    this.formDatosContrato.valueChanges.subscribe(form => {
      if (form.Salary && this.commonMetodService._validarDateMoney(form.Salary)
        ) {
        this.formDatosContrato.patchValue({
          Salary: this.currencyPipe.transform(form.Salary.toString().replace(/\D/g, '').replace(/^0+/, ''),
            'USD', 'symbol', '1.0-0').replace(/,/gi, '.')
        }, {emitEvent: false});
      }
      if (form.AuxiliaryTransport && this.commonMetodService._validarDateMoney(form.AuxiliaryTransport)
      ) {
        this.formDatosContrato.patchValue({
          AuxiliaryTransport: this.currencyPipe.transform(form.AuxiliaryTransport.toString().replace(/\D/g, '').replace(/^0+/, ''),
            'USD', 'symbol', '1.0-0').replace(/,/gi, '.')
        }, {emitEvent: false});
      }
      if (form.TotalEarnings && this.commonMetodService._validarDateMoney(form.TotalEarnings)
      ) {
        this.formDatosContrato.patchValue({
          TotalEarnings: this.currencyPipe.transform(form.TotalEarnings.toString().replace(/\D/g, '').replace(/^0+/, ''),
            'USD', 'symbol', '1.0-0').replace(/,/gi, '.')
        }, {emitEvent: false});
      }
    });

    // Cambios en Formulario Activar boton  SAVE
    this.formPersonal.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormPersonal === false) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formVigenciaArlExigida.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormVigenciaArlExigida === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formVigencia.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormVigencia === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formPersonalCV.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormPersonalCV === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formVaccine.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormVaccine === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formDatosContrato.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormContractIndividual === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
    this.formOtrosDatos.valueChanges.subscribe(value => {
      if (this.changeAfterfillFormOtrosDatos === true) {
        if (this.exitPermissionCompany('personals.update')) {
          this.flagChangeDataBtnSave = true;
        }
      }
    });
  }

  private moveToTop<T>(list: T[], pred: (x: T) => boolean): T[] {
    const idx = list.findIndex(pred);
    if (idx <= 0) { return list.slice(); }
    const item = list[idx];
    return [item, ...list.slice(0, idx), ...list.slice(idx + 1)];
  }

  private prioritizeContracts(list: any[]): any[] {
    return [...list].sort((a, b) => {
      const aAct = a?.IsActive ? 0 : 1;
      const bAct = b?.IsActive ? 0 : 1;
      if (aAct !== bAct) { return aAct - bAct; }
      const aF = a?.FinishDate ? new Date(a.FinishDate).getTime() : Number.POSITIVE_INFINITY;
      const bF = b?.FinishDate ? new Date(b.FinishDate).getTime() : Number.POSITIVE_INFINITY;
      return aF - bF;
    });
  }

  private refreshContractsView(focusId?: string | number): void {
    let ordered = this.prioritizeContracts(this.filterContracts);

    if (focusId !== undefined) {
      const same = (c: any) => String(c?.ContractId) === String(focusId);
      ordered = this.moveToTop(ordered, same);
    }
    this.contracts = ordered;
  }

  private updateBannerFlags(): void {
    const list = this.contractsLabor || [];
    this.hasAnyContracts = list.length > 0;
    this.hasAnyActiveContracts = list.some(c => !this.isLaborInactive(c));
  }

  private setLoadingLabor(value: boolean): void {
    this.isLoadingLaborContracts = value;
  }

  ngOnInit(): void {
    const localCities = this.commonService.getDaneCityLocal();
    if (localCities && localCities.length > 0) {
      this.daneCity = localCities;
    }
    const localExpCities = this.commonService.getCitiesLocal(0);
    if (localExpCities && localExpCities.length > 0) {
      this.citiesExpedicion = localExpCities;
    }
    const localDocTypes = this.commonService.getCommonOptionsLocal('CoPs_CompanyDocumentType');
    if (localDocTypes && localDocTypes.length > 0) {
      this.companyDocumentType = this.filterCompanyDocumentTypes(localDocTypes, this.formPersonal?.get('Nationality')?.value, this.personal?.DocumentType);
    }
    this.exitExpansionConfig();
    this.restoreViewFlagsAfterReload();
  }

  private restoreViewFlagsAfterReload(): void {
    const savedActive = localStorage.getItem('cardsPersonal_showOnlyActive');
    this.showOnlyActive = savedActive ? savedActive === '1' : true;
    localStorage.removeItem('cardsPersonal_showOnlyActive');

    const savedBanner = localStorage.getItem('cardsPersonal_showInactiveBanner');
    this.showOnlyInactiveBanner = savedBanner === '1' && this.showOnlyActive;
    localStorage.removeItem('cardsPersonal_showInactiveBanner');
  }

  getHistory() {
    this.btn_menuHistory = true;
    this.commonService.getHistory(this.personalId).subscribe(rest => {
      this.history = rest.sort((a, b) => a.UpdateDate < b.UpdateDate ? 1 : -1);
    });
  }

  openFaceTraceDialog(): void {
    const hasViewPerm = this.exitPermissionCompany('personals.facetrace.view');
    if (!hasViewPerm) { return; }

    const dialogRef = this.dialogService.openDialogFaceTrace({
      personalCompanyInfoId: this.personalCompanyInfoId,
      employeeName: `${this.formPersonal.get('Name')?.value || ''} ${this.formPersonal.get('LastName')?.value || ''}`.trim(),
      permissions: {
        canView: hasViewPerm,
        canDelete: this.exitPermissionCompany('personals.facetrace.delete'),
        canReprocess: this.exitPermissionCompany('personals.facetrace.reprocess')
      },
      s3Bucket: this.s3Bucket
    });

    if (dialogRef && dialogRef.afterClosed) {
      dialogRef.afterClosed().subscribe(() => {
        this.checkPhotoQualityAndSyncRequestChange(this.personalCompanyInfoId);
      });
    }
  }

  validateListF(documentType, documentNumber, CompanyInfoId) {
    // Reset preventivo para evitar mostrar datos del personal anterior mientras responde la API
    this.flagListF = false;
    this.flagVeto = false;
    this.sanctionedByExtraTime = false;

    this.contratingService.getPersonalBlackListInfoSanction(documentType, documentNumber, CompanyInfoId)
      .subscribe((rest: BlacklistResponse) => {
        this.flagListFInfo = rest;
        this.flagBlackListFuture = rest?.FutureBlackList;
        this.flagListF = rest?.BlackList;
        this.disabledFormularios();
      });

    this.contratingService.getPersonalBlackListInfoVetos(documentType, documentNumber, CompanyInfoId)
      .subscribe((rest: BlacklistResponse) => {
        this.flagVetoInfo = rest;
        this.flagBlackListFutureVeto = rest?.FutureBlackList;
        this.flagVeto = rest?.BlackList;
        this.disabledFormularios();
      });

    this.contratingService.getPersonalBlackListByType(documentType, documentNumber, CompanyInfoId, 'block')
      .subscribe((rest: BlacklistResponse) => {
        this.sanctionedByExtraTime = rest?.BlackList === true;
      }, () => {
        this.sanctionedByExtraTime = false;
      });
  }

  getPersonalContracts() {
    this.personalService.getPersonalContracts(this.personalCompanyInfoId).subscribe((rest: any) => {
      if (rest !== undefined && rest !== null){
        this.personalContractPosition = rest;
        this.getSelectedContractsPosition(false);
      }
    });
  }

  getSelectedContractsPosition(changeContract) {
      if (changeContract === true) {
        this.positionSujester = [];
      }
      this.personalContractPosition.forEach(x => {
        if (x.EmployerId === this.contractSelected?.EmployerId) {
          if (this.positionSujester.length === 0) {
            this.positionSujester.push(x.Position);
          }
          if (this.positionSujester.length > 0 && this.exitPositionSujester(x.Position) === false) {
            this.positionSujester.push(x.Position);
          }
        }
      });
  }

  exitPositionSujester(Position): boolean {
    let exit: boolean;
    const data = this.positionSujester.find(x => x === Position);
    data !== undefined ? exit = true : exit = false;
    return exit;
  }

  getServicesPersonalCV() {
    const educationalLevel$ = this.commonService.getCommonOptionsLocalOrApi('CoPs_EducationalLevel').pipe(
      take(1),
      catchError(() => of([] as CommonOptions[]))
    );

    const maritalStatus$ = this.commonService.getCommonOptionsLocalOrApi('CoPs_MaritalStatus').pipe(
      take(1),
      catchError(() => of([] as CommonOptions[]))
    );

    const socialStratum$ = this.commonService.getCommonOptionsLocalOrApi('CoPs_SocialStratum').pipe(
      take(1),
      catchError(() => of([] as CommonOptions[]))
    );

    forkJoin({
      educationalLevel: educationalLevel$,
      maritalStatus: maritalStatus$,
      socialStratum: socialStratum$
    }).subscribe(({ educationalLevel, maritalStatus, socialStratum }) => {
      this.educationalLevel = [...educationalLevel].sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.maritalStatus = [...maritalStatus].sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.socialStratum = socialStratum;
      this.getPersonalCV();
    });

    this.commonService.getJobs().subscribe(jobs => {
      this.jobs = jobs;
    });
  }

  getPersonalCV() {
    this.personalService.getPersonalCV(this.personalId).subscribe((restPersonalCV: any) => {
      this.formPersonalCV.get('PersonalCompanyInfoId').setValue(restPersonalCV.PersonalCompanyInfoId);
      this.formPersonalCV.get('EducationalLevelId').setValue(
        restPersonalCV.EducationalLevelId !== null ? restPersonalCV.EducationalLevelId : this.getEducationlLevendesconocido());
      this.formPersonalCV.get('ExperienceYears').setValue(restPersonalCV.ExperienceYears !== null ? restPersonalCV.ExperienceYears : 0 );
      this.formPersonalCV.get('ExperienceMonths').setValue(restPersonalCV.ExperienceMonths !== null ? restPersonalCV.ExperienceMonths : 0);
      if (restPersonalCV && restPersonalCV.JobCode) {
        this.formPersonalCV.get('JobCode').setValue(restPersonalCV.JobCode);
      }
      this.urlDataStudyCertificate = restPersonalCV.StudyCertificate;
      this.urlDataExperienceCertificate = restPersonalCV.ExperienceCertificate;
      this.restPersonalCV = restPersonalCV;
      setTimeout(() => {
        this.changeAfterfillFormPersonalCV = true;
      }, 4000);
  }, (error) => {
    setTimeout(() => {
      this.changeAfterfillFormPersonalCV = true;
    }, 4000);
  });
  }

  getRefrestHistory() {
    if (this.btn_menuHistory === false) { return; }
    this.controHistory.setValue(1);
    this.commonService.getHistory(this.personalId).subscribe(rest => {
      this.history = rest.sort((a, b) => a.UpdateDate < b.UpdateDate ? 1 : -1);
    });
  }

  getEducationlLevendesconocido(): number {
    let id: number;
    const data = this.educationalLevel.find(x => x.Description === 'DESCONOCIDO');
    data !== undefined ? id = data.Id : id = null;
    return id;
  }

  getMaritalStatusdesconocido(): number {
    let id: number;
    const data = this.maritalStatus.find(x => x.Description === 'DESCONOCIDO');
    data !== undefined ? id = data.Id : id = null;
    return id;
  }

  getSocialStratumdesconocido(): number {
    let id: number;
    const data = this.socialStratum.find(x => x.Description === 'Desconocido');
    data !== undefined ? id = data.Id : id = null;
    return id;
  }

  openDocumentsPersonalCV(type: 'StudyCertificate' | 'ExperienceCertificate') {
    const MAX = 10_000_000;
    const adminId = this.personal?.CompanyInfoId || '';
    const isRestrictedAdmin =
      adminId === '211865ab-0b40-4cfd-9b43-03e4ceb537a4' ||
      adminId === '201bb4d4-3c4f-4f50-8d3f-be058aac50d6';

    const isAllowedDoc = (f: File) => {
      const name = (f?.name || '').toLowerCase();
      const mimeType = f?.type || '';
      const okMime = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'].includes(mimeType);
      const okExt  = /\.(pdf|jpg|jpeg|png)$/i.test(name);
      return okMime && okExt;
    };

    const applyResult = (restDialog: any, kind: 'study' | 'exp') => {
      if (!restDialog) { return; }

      const fd: FormData | null =
        restDialog?.FormData instanceof FormData ? restDialog.FormData : null;

      if (fd) {
        const file = fd.get('File') as File | null;
        if (!file) { return; }

        if (file.size > MAX) {
          this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', undefined, 5000);
          return;
        }
        if (isRestrictedAdmin && !isAllowedDoc(file)) {
          this.snackBService.openWarning('Solo se permiten archivos PDF, JPG o PNG.', undefined, 5000);
          return;
        }

        if (kind === 'study') {
          this.formDataStudyCertificate = fd;
          this.filesStudyCertificate = restDialog.File ?? [];
        } else {
          this.formDataExperienceCertificate = fd;
          this.filesExperienceCertificate = restDialog.File ?? [];
        }
        return;
      }

      const files: File[] = Array.isArray(restDialog?.File) ? restDialog.File : [];
      if (!files.length) { return; }

      const tooBig = files.find(f => f.size > MAX);
      if (tooBig) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', undefined, 5000);
        return;
      }
      if (isRestrictedAdmin && files.some(f => !isAllowedDoc(f))) {
        this.snackBService.openWarning('Solo se permiten archivos PDF, JPG o PNG.', undefined, 5000);
        return;
      }

      if (kind === 'study') {
        this.filesStudyCertificate = files;
        this.formDataStudyCertificate = restDialog.FormData || undefined;
      } else {
        this.filesExperienceCertificate = files;
        this.formDataExperienceCertificate = restDialog.FormData || undefined;
      }
    };

    if (type === 'StudyCertificate') {
      this.dialogService.openDialogChangeOneFile('Complete', this.urlDataStudyCertificate || '',
        ((this.flagListF === true || this.flagVeto === true) || !this.exitPermissionCompany('personalstudiescert.view') ? 'show' : 'showDelete'),
        this.filesStudyCertificate.length > 0 ? this.filesStudyCertificate : []).afterClosed().subscribe(rest => {
        this.filesStudyCertificate = [];
        this.formDataStudyCertificate = undefined;
        applyResult(rest, 'study'); });
    } else {
      this.dialogService.openDialogChangeOneFile('Complete', this.urlDataExperienceCertificate || '',
        ((this.flagListF === true || this.flagVeto === true) || !this.exitPermissionCompany('personalespiriencecert.view') ? 'show' : 'showDelete'),
        this.filesExperienceCertificate.length > 0 ? this.filesExperienceCertificate : []).afterClosed().subscribe(rest => {
        this.filesExperienceCertificate = [];
        this.formDataExperienceCertificate = undefined;
        applyResult(rest, 'exp');
      });
    }
  }

  servicesPersonal() {
    forkJoin({
      nationality: this.commonService.getCommonOptionsLocalOrApi('CoPs_Nationality'),
      rh:          this.commonService.getCommonOptionsLocalOrApi('CoPs_RH'),
      sex:         this.commonServices.getCommonOptionsLocalOrApi('CoPs_Sex'),
      countrys:    this.commonServices.getCommonOptionsLocalOrApi('CoPs_Country'),
      vaccineType: this.commonServices.getCommonOptionsLocalOrApi('CoPs_VaccineType'),
      vaccinationStatus: this.commonServices.getCommonOptionsLocalOrApi('CoPs_VaccinationStatus'),
    }).subscribe(({ nationality, rh, sex, countrys, vaccineType, vaccinationStatus }) => {
      this.nationality        = nationality;
      this.rh                 = rh.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.sex                = sex.sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.countrys           = countrys;
      this.vaccineType        = vaccineType;
      this.vaccinationStatus  = vaccinationStatus;
    });

    this.employerService.getSecurityReferences().subscribe(data => {
      this.securityReferences = data;
      this.eps = this.securityReferences.filter(x => x.Type === TypeSecurityReference.EPS
        && x.IsActive === true).sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      this.afp = this.securityReferences.filter(x => x.Type === TypeSecurityReference.AFP
        && x.IsActive === true).sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
    });

    const localExpCities = this.commonService.getCitiesLocal(0);
    if (localExpCities && localExpCities.length > 0) {
      this.citiesExpedicion = localExpCities;
    }
    this.commonService.getCities(0).subscribe((data: City[]) => {
      this.citiesExpedicion = data;
    });

    this.getDaneCity();
  }

  getDaneCity() {
    const localCities = this.commonService.getDaneCityLocal();
    if (localCities && localCities.length > 0) {
      this.daneCity = localCities;
    }
    this.commonService.getDaneCity().subscribe((daneCity: DaneCity[]) => {
      this.daneCity = daneCity;
    });
  }

  getCitiesNacimiento(numberContry: NumberCountry, change?) {
    if (numberContry !== '' && numberContry !== undefined && numberContry !== null) {
      this.commonService.getCities(numberContry).subscribe((data: City[]) => {
        this.citiesNacimiento = data;
        // Si existe un cambio en la ciudad de nacimiento tiene que seleccionar ciudad desconocida
        if (change !== undefined) {
          const cityDesconocido = this.citiesNacimiento.find(x => x.Name === 'DESCONOCIDO');
          if (cityDesconocido !== undefined) {
            this.formPersonal.get('CityOfBirthCode')?.setValue(cityDesconocido.Code);
          }
        }
      });
    }
  }

  getVaccine(Id) {
    this.personalService.getVaccine(Id).subscribe((rest: any) => {
      if ( rest.VaccineStatusId === '' || rest.VaccineStatusId === null || rest.VaccineStatusId === 0) {
        this.formVaccine.get('VaccineStatusId').setValue(this.getIdStatus('No Informa'));
      } else {
        this.formVaccine.get('VaccineStatusId').setValue(rest.VaccineStatusId);
      }
      this.formVaccine.get('VaccineTypeId').setValue(rest.VaccineTypeId);
      this.formVaccine.get('AppliedDose').setValue(rest.AppliedDose);
      this.formVaccine.get('VaccineObservations').setValue(rest.VaccineObservations);

      this.personalStatus = rest?.VaccineStatus?.Description;
      setTimeout(() => {
        this.changeAfterfillFormVaccine = true;
      }, 3000);
    });
  }

  getIdStatus(desciption): number {
    let id: number;
    const status = this.vaccinationStatus.find(x => x.Description === desciption);
    status !== undefined ? id = status.Id : id = 0;
    return id;
  }

  getDescriptionStatus(id): string {
    let description: string;
    const status = this.vaccinationStatus.find(x => x.Id === id);
    status !== undefined ? description = status.Description : description = '';
    return description;
  }

  getTown(CodeCity) {
    if (CodeCity !== '' && CodeCity !== null && CodeCity !== undefined) {
      this.contratingService.getTownIdCity(CodeCity).subscribe((data: any) => {
        this.town = data;
      });
    }
  }

  getCalculateStateDateFromIcon(date): string {
    let response: string;
    response = this.fechasService.calculateStateDateFromIcon(date);
    return response;
  }

  fillFormPersonal() {
      // Person
    this.formPersonal.get('Name').setValue(this.personal.Name);
    this.formPersonal.get('LastName').setValue(this.personal.LastName);
    const nat = this.personal?.Nationality != null ? this.personal.Nationality.toString() : '0';
    this.formPersonal.get('Nationality').setValue(nat);
    const docType = String(this.personal?.DocumentType ?? '').trim();
    this.formPersonal.get('DocumentType').setValue(docType);
    this.formPersonal.get('DocumentNumber').setValue(this.personal.DocumentNumber);
    this.personal.DocumentRaw === null || this.personal.DocumentRaw === 'null' ?
      this.isCreateAppPersonal = false : this.isCreateAppPersonal = true;
    this.validateListF(this.personal.DocumentType, this.personal.DocumentNumber, this.personal.CompanyInfoId);
    this.formPersonal.get('CityOfBirthCode').setValue(this.personal.CityOfBirthCode !== null ? this.personal.CityOfBirthCode : '');
    if (this.personal.CityOfBirthCode !== null) {this.getCitiesNacimiento(this.personal.CityOfBirthCode.substring(0, 1)); }
    this.formPersonal.get('contryNalcionality').setValue(this.personal.CityOfBirthCode !== null ?
      this.personal.CityOfBirthCode.substring(0, 1) : '');
    this.formPersonal.get('RH').setValue(this.personal.RH);
    this.formPersonal.get('Sex').setValue(this.personal.Sex);
    this.formPersonal.get('BirthDate').setValue(this.fechasService.formatBirthDate(this.personal.BirthDate));
    // PersonalEmployerInfo
    this.formPersonal.get('CityCode').setValue(this.personal.CityCode);
    this.getTown(this.personal.CityCode);
    this.formPersonal.get('TownId').setValue(this.personal.TownId);
    this.formPersonal.get('Address').setValue(this.personal.Address);
    this.formPersonal.get('PhoneNumber').setValue(this.personal.PhoneNumber);
    this.formPersonal.get('EmergencyContact').setValue(this.personal.EmergencyContact);
    this.formPersonal.get('EmergencyContactPhone').setValue(this.personal.EmergencyContactPhone);
    this.formPersonal.get('RelationshipWithContact').setValue(this.personal.RelationshipWithContact);
    this.formPersonal.get('Photo').setValue(this.personal.Photo);
    this.formPersonal.get('Email').setValue(this.personal.Email?.toLowerCase());
    this.formPersonal.get('AfpId').setValue(this.personal.AfpId);
    this.formPersonal.get('EpsId').setValue(this.personal.EpsId);

    // datos expedicion document
    this.controlExpeditionDate.setValue(this.personal.ExpeditionDate);
    this.controlExpeditionPlace.setValue(this.personal.ExpeditionPlaceCode);
    this.formPersonalCV.get('JobCode').setValue(this.personal.JobCode);
    this.formPersonalCV.get('MaritalStatusId').setValue(this.personal.MaritalStatusId !== null ?
      this.personal.MaritalStatusId : this.getMaritalStatusdesconocido());
    this.formPersonalCV.get('NumberOfChilds').setValue(this.personal.NumberOfChilds !== null ? this.personal.NumberOfChilds : 0);
    this.formPersonalCV.get('NumberOfDependants').setValue(this.personal.NumberOfDependants !== null ?
      this.personal.NumberOfDependants : 0);
    this.formPersonalCV.get('SocialStratumId').setValue(this.personal.SocialStratumId !== null ?
      this.personal.SocialStratumId : this.getSocialStratumdesconocido());
    this.formPersonalCV.get('Medicines').setValue(this.personal.Medicines);
    this.formPersonal.get('TownId')?.setValue(parseInt(this.personal.TownId, 10));

    const nationality = this.formPersonal.get('Nationality').value;

    this.commonService.getCommonOptionsLocalOrApi('CoPs_CompanyDocumentType').subscribe((options: CommonOptions[]) => {
      this.companyDocumentType = this.filterCompanyDocumentTypes(options, nationality, docType);
      this.formPersonal.get('DocumentType').setValue(docType);
    });
    this.getEmployerAll();
    // Cambia variable al primer llenado del formulario de Personal
    setTimeout(() => {
      this.changeAfterfillFormPersonal = false;
    }, 1000);
  }

  getEmployerAll() {
    this.commonService.getAllEmployersCompanyId(this.personal.CompanyInfoId).subscribe((data: any) => {
      this.allEmployers = data.sort((a, b) => (a.Name > b.Name) ? 1 : ((b.Name > a.Name) ? -1 : 0));
    });
  }

  onSelectedAllEmployer(id) {
    this.formVigencia.get('EmployerId').setValue(id);
    // Change EMployer para preguntar si copiar documentos del antirior empleador
    this.changeEmployerId = true;
    const employerNew = this.allEmployers.find(x => x.Id === id);
    this.formVigencia.get('EmployerName').setValue(employerNew.Name);
    this.formVigencia.get('EmployerId').setValue(employerNew.Id);
  }

  eventSave() {
    if ((this.companyIdUserLogin === 'f3dfc3f6-7da3-423b-bb55-5631f6517d31' ||
        this.companyIdUserLogin === 'f783fe09-bf7a-497b-a3f2-ce4e20969d2e') && this.exitPersonalEmployerByPersonalPOSTPUT === undefined) {
      this.snackBService.openWarning('Por favor crear contrato laboral para continuar', '', 5000);
      this.postIndividualContractLabor();
    } else {
      if (this.flagChangeCCFPersonal === true) {
        const modelPersonalCV = {
          personalCompanyInfoId: this.personalCompanyInfoId,
          EmployerInfoId: this.personalInfo.EmployerId === null
            ? this.personalInfo.SubContractorId
            : this.personalInfo.EmployerId,
          CCFId: this.formPersonal.get('CCFId').value,
          Module: 'Personal'
        };
        this.employerService.postEmployerPersonalCCF(modelPersonalCV).subscribe(() => {
          this.loadCCFPersonal(this.personalCompanyInfoId, this.personalInfo.SubContractorId);
        });
      }

      if (this.formPersonal.status === 'VALID') {
        this.putIndividualContractLabor(() => {
          this.putPersonalFull();
          this.postVaccice();

          const lastDateFinish = new Date(this.personalInfo.FinishDate);
          const dateFormFinish = new Date(this.formVigencia.get('FinishDateContract').value);
          lastDateFinish.setSeconds(0, 0);
          dateFormFinish.setSeconds(0, 0);

          const isDifferentFinish = lastDateFinish.getTime() !== dateFormFinish.getTime();

          if (isDifferentFinish) {
            this.contractService.getIsContractPersonalCompanyInfoId(this.contractSelected.ContractId, this.personalId).subscribe(
                () => {this.flowChangeState(); }, (error: HttpErrorResponse) => {
                  if (error.status === 400) {
                    this.dialogService.openDialogMovePersonalInfo(true, error, 'Desea trasladarlo?',
                      false).afterClosed().subscribe(restDialog => {
                        if (restDialog === true) {
                          const pesonalCompany = {
                            AfpId: this.formPersonal.get('AfpId').value,
                            ContractId: this.contractSelected.ContractId,
                            EmployerId: null,
                            EpsId: this.formPersonal.get('EpsId').value,
                            PersonalCompanyInfoId: this.personalId,
                            Position: this.formVigencia.get('Position').value,
                            TypeARL: this.formVigenciaArlExigida.get('TypeARL').value,
                            StartDate: this.formVigencia.get('StartDateContract').value,
                            FinishDate: this.formVigencia.get('FinishDateContract').value,
                            Module: 'Personal'
                          };
                          this.contractService.postMovePersonalInfoContract(this.contractSelected.ContractId, pesonalCompany)
                            .subscribe((restMOvePersonal: any) => {this.flowChangeState(); });
                        } else {
                          this.flowChangeState();
                        }
                      });
                  }
                }
              );
          } else {
            this.flowChangeState();
          }

          if (this.deferLaborResort) {
            this.rebuildVisibleLaborContractsSorted?.();
            this.deferLaborResort = false;
          }

          this.getContractsOffline(this.indexSelect);
        });
      } else {
        this.snackBService.openWarning('Complete la información requerida del personal', '', 3000);
        this.formPersonal.markAllAsTouched();
      }
    }
  }

  // Contratos VINCULADOS A LOS CONTRATOS Y PROYECTOS
  changeinputPositionContract(value) {
    this.formVigencia.get('Position').setValue(value);
  }

  changeDateFinishDateContractTime(date, isFinishDate) {
    if (date !== undefined && date !== '' && date !== null){
      if (isFinishDate === true) {
        this.formVigencia.get('FinishDateContract').setValue(date);
      } else {
        this.formVigencia.get('StartDateContract').setValue(date);
      }
    }
  }

  // contratos CONTRATOS LABORALES
    changeDateFinishDateContractLabor(date, isFinishDate, index) {
      const ordate = this.fechasService.getDateFormatDatePiker(
        this.fechasService.formatDateYYYYMMDDdatePiker(date)
      );

      if (!isFinishDate) {
        this.visibleLaborContractsSorted[index].StartDate = ordate;
        this.formDatosContrato.get('StartDate')?.setValue(ordate);
      } else {
        this.visibleLaborContractsSorted[index].EndDate = ordate;
        this.formDatosContrato.get('EndDate')?.setValue(ordate);
      }

      // Posponer resort hasta que se guarde
      this.deferLaborResort = true;

      // Activar el botón Guardar si aplica
      this.flagChangeDataBtnSave = true;
  }

  changeinputContractLaborContractNumber(value, index) {
    this.visibleLaborContractsSorted[index].ContractNumber = value;
    this.formDatosContrato.get('ContractNumber').setValue(value);
  }

  changeinputContractLaborPositionName(value, index) {
    this.visibleLaborContractsSorted[index].PositionName = value;
    this.formDatosContrato.get('PositionName').setValue(value);
  }

  onSelectedEmployerInfoId(value, index) {
    this.visibleLaborContractsSorted[index].EmployerInfoId = value;
    this.formDatosContrato.get('EmployerInfoId').setValue(value);
  }

  onSelectedContractTypeId(value, index) {
    this.visibleLaborContractsSorted[index].ContractTypeId = value;
    this.formDatosContrato.get('ContractTypeId').setValue(value);
  }

  onSelectedBankId(value, index) {
    this.visibleLaborContractsSorted[index].BankId = value;
    this.formDatosContrato.get('BankId').setValue(value);
  }

  onSelectedBankAccountTypeId(value, index) {
    this.visibleLaborContractsSorted[index].BankAccountTypeId = value;
    this.formDatosContrato.get('BankAccountTypeId').setValue(value);
  }

  onSelectedProjectId(value, index) {
    this.projectChangeSnapshot = {
      index,
      previousProjectId: this.visibleLaborContractsSorted[index].ProjectId,
      previousWorkShiftId: this.visibleLaborContractsSorted[index].WorkShiftId,
      previousWorkShiftList: this.visibleLaborContractsSorted[index].workShiftList
    };

    this.workShift = [];

    this.visibleLaborContractsSorted[index].ProjectId = value;
    this.visibleLaborContractsSorted[index].WorkShiftId = null;
    this.visibleLaborContractsSorted[index].ControlWorkShift?.setValue(null, { emitEvent: false });

    if (this.visibleLaborContractsSorted[index]) {
      this.visibleLaborContractsSorted[index].workShiftList = [];
    }

    this.formDatosContrato.get('ProjectId').setValue(value);
    this.formDatosContrato.get('WorkShiftId').setValue(null);

    this.getPersonalWorkShiftrprojectId(value, null, index);
  }

  revertProjectChange() {
    const snapshot = this.projectChangeSnapshot;
    if (!snapshot) { return; }
    const { index, previousProjectId, previousWorkShiftId, previousWorkShiftList } = snapshot;
    const item = this.visibleLaborContractsSorted[index];
    if (item) {
      item.ProjectId = previousProjectId;
      item.WorkShiftId = previousWorkShiftId;
      item.workShiftList = previousWorkShiftList;
      item.ControlProjectId?.setValue(previousProjectId, { emitEvent: false });
      item.ControlWorkShift?.setValue(previousWorkShiftId, { emitEvent: false });
    }
    if (index === this.indexSelectContracLabor) {
      this.formDatosContrato.get('ProjectId')?.setValue(previousProjectId, { emitEvent: false });
      this.formDatosContrato.get('WorkShiftId')?.setValue(previousWorkShiftId, { emitEvent: false });
    }
    this.projectChangeSnapshot = null;
  }

  onSelectedWorkShift(value, index) {
    this.visibleLaborContractsSorted[index].WorkShiftId = value;
    this.formDatosContrato.get('WorkShiftId').setValue(value);
  }

  canOpenWorkScheduleCalendar(index: number): boolean {
    return this.exitPermissionCompany('personalsemployerscontract.viewShiftScheduling')
      && this.indexSelectContracLabor === index
      && !(this.flagListF === true || this.flagVeto === true);
  }

  private canEditPastSchedule(): boolean {
    return (this.userAuth?.claims || []).includes('schedule.edit-past');
  }

  openWorkScheduleCalendarDialog(item: any, index: number): void {
    const project = this.projects.find(p => p.Id === item.ProjectId);
    const canEditShiftScheduling = this.exitPermissionCompany('personalsemployerscontract.EditShiftScheduling');

    this.dialogService.openDialogWorkScheduleCalendar({
      personalEmployerId: item.Id,
      personName: `${this.personal?.Name || ''} ${this.personal?.LastName || ''}`.trim(),
      documentLabel: this.personal?.DocumentType && this.personal?.DocumentNumber
        ? `${this.personal.DocumentType} ${this.personal.DocumentNumber}` : undefined,
      positionLabel: item.PositionName,
      employerLabel: item.EmployerName,
      projectLabel: project?.Name,
      isActive: !this.isLaborInactive(item),
      projectId: item.ProjectId,
      adminInfoId: this.personal?.CompanyInfoId,
      canEdit: canEditShiftScheduling,
      canEditShiftScheduling,
      canEditPast: this.canEditPastSchedule(),
      workShifts: item.workShiftList
    });
  }

  getWorkplaceName(item: any): string {
    return this.projects.find(p => p.Id === item.ProjectId)?.Name || 'Sin asignar';
  }

  canEditWorkplace(index: number): boolean {
    return this.exitPermissionCompany('personalsemployerstermination.Workplace')
      && this.indexSelectContracLabor === index
      && !(this.flagListF === true || this.flagVeto === true);
  }

  openChangeWorkplaceDialog(item: any, index: number): void {
    if (!this.canEditWorkplace(index)) { return; }

    const currentProject = this.projects.find(p => p.Id === item.ProjectId);

    this.dialogService.openDialogChangeWorkplace({
      employeeName: `${this.personal?.Name || ''} ${this.personal?.LastName || ''}`.trim(),
      contractNumber: item.ContractNumber,
      currentProjectId: item.ProjectId,
      currentProjectName: currentProject?.Name || '',
      projects: this.projects,
      contract: item,
      personalCompanyInfoId: this.personalCompanyInfoId,
      history: []
    }).afterClosed().subscribe((result: DialogChangeWorkplaceResult) => {
      if (!result?.confirmed || !result.updatedContract) { return; }

      const updated = result.updatedContract;
      item.ProjectId = updated.ProjectId;
      item.ControlProjectId?.setValue(updated.ProjectId, { emitEvent: false });

      if (index === this.indexSelectContracLabor) {
        this.formDatosContrato.get('ProjectId')?.setValue(updated.ProjectId, { emitEvent: false });
      }

      this.getPersonalWorkShiftrprojectId(updated.ProjectId, updated.WorkShiftId, index);
    });
  }

  onSelectedHasExtraTime(value, index) {
    this.hasExtraTimeChangeSnapshot = { index, previousValue: this.visibleLaborContractsSorted[index].HasExtraTime };
    this.visibleLaborContractsSorted[index].HasExtraTime = value;
    this.formDatosContrato.get('HasExtraTime').setValue(value);
  }

  revertHasExtraTimeChange() {
    const snapshot = this.hasExtraTimeChangeSnapshot;
    if (!snapshot) { return; }
    const { index, previousValue } = snapshot;
    const item = this.visibleLaborContractsSorted[index];
    if (item) {
      item.HasExtraTime = previousValue;
      item.ControlHasExtraTime?.setValue(previousValue, { emitEvent: false });
    }
    if (index === this.indexSelectContracLabor) {
      this.formDatosContrato.get('HasExtraTime').setValue(previousValue, { emitEvent: false });
    }
    this.hasExtraTimeChangeSnapshot = null;
  }

  getPersonalWorkShiftrprojectId(ProjectId, workShiftId?: any, index?: number) {
    if (!ProjectId) {
      this.workShift = [];
      this.formDatosContrato.get('WorkShiftId').setValue(null);

      if (index !== undefined && this.visibleLaborContractsSorted[index]) {
        this.visibleLaborContractsSorted[index].WorkShiftId = null;
        this.visibleLaborContractsSorted[index].ControlWorkShift?.setValue(null, { emitEvent: false });
        this.visibleLaborContractsSorted[index].workShiftList = [];
      }
      return;
    }

    this.personalService.getPersonalWorkShiftrprojectId(ProjectId).subscribe((rest: any) => {
      const activeWorkShifts = (rest || []).filter((w: any) => w.IsActive !== false);
      this.workShift = activeWorkShifts;

      if (index !== undefined && this.visibleLaborContractsSorted[index]) {
        this.visibleLaborContractsSorted[index].workShiftList = activeWorkShifts;
      }

      if (workShiftId !== undefined && workShiftId !== null) {
        this.formDatosContrato.get('WorkShiftId').setValue(workShiftId, { emitEvent: false });

        if (index !== undefined && this.visibleLaborContractsSorted[index]) {
          this.visibleLaborContractsSorted[index].WorkShiftId = workShiftId;
          this.visibleLaborContractsSorted[index].ControlWorkShift?.setValue(workShiftId, { emitEvent: false });
        }
      }
    });
  }

  getProjects() {
    this.projectService.getProjects().subscribe((rest: any) => {
      this.projects = rest;
    });
  }

  changeinputContractLaborSalary(value, index) {
    let setValue = '0';
    if (value !== '$0' && value !== '0' && value !== '' && value !== 0 && value !== null && value !== undefined){
      this.visibleLaborContractsSorted[index].Salary = this.currencyPipe.transform(value.toString().replace(/\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.0-0').replace(/,/gi, '.');
      setValue = this.currencyPipe.transform(value.toString().replace(/\D/g, '').replace(/^0+/, ''),
        'USD', 'symbol', '1.0-0').replace(/,/gi, '.');
    }
    this.formDatosContrato.get('Salary').setValue(setValue);
  }

  changeinputAuxiliaryTransport(value, index) {
    let setValue = '0';
    if (value !== '$0' && value !== '0' && value !== '' && value !== 0 && value !== null && value !== undefined){
      this.visibleLaborContractsSorted[index].TransportationAllowance = this.currencyPipe.transform(value.toString().replace(
        /\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.0-0').replace(/,/gi, '.');
      setValue = this.currencyPipe.transform(value.toString().replace(/\D/g, '').replace(/^0+/, ''),
        'USD', 'symbol', '1.0-0').replace(/,/gi, '.');
    }
    this.formDatosContrato.get('AuxiliaryTransport').setValue(setValue);
  }

  changeinputTotalEarnings(value: string, index: number) {
    let setValue = '0';
    if (value && value !== '$0' && value !== '0' && value !== '') {
      const numericValue = value.toString().replace(/\D/g, '');
      const formattedValue = this.currencyPipe.transform(numericValue, 'COP', 'symbol', '1.0-0').replace(/,/g, '.');

      this.visibleLaborContractsSorted[index].TotalEarnings = formattedValue;
      setValue = formattedValue;
    }

    this.formDatosContrato.get('TotalEarnings').setValue(setValue);
  }

  formatCurrency(value: number): string {
    if (value === null || value === undefined) {
      return '';
    }
    return this.currencyPipe.transform(value, 'COP', '$', '1.0-0').replace(/,/g, '.');
  }

  changeinputContractLaborBankAccount(value, index) {
    this.visibleLaborContractsSorted[index].BankAccount = value;
    this.formDatosContrato.get('BankAccount').setValue(value);
  }

  flowChangeState() {
    this.personalService.getContractPersonalInfoId(this.contractSelected.ContractId, this.personalId)
      .subscribe((personalInfoContract: PersonalInfoContract) => {
          const personalUpdateModel = {
            ...this.personalInfo,
            EpsId: this.formPersonal.get('EpsId').value,
            StartDate: this.formVigencia.get('StartDateContract').value,
            FinishDate: this.formVigencia.get('FinishDateContract').value,
            EmployerId: this.formVigencia.get('EmployerId').value,
            Position: this.formVigencia.get('Position').value,
            TypeARL: this.formVigenciaArlExigida.get('TypeARL').value,
            Requirements: personalInfoContract.Requirements,
            tillEndOfDay: false,
            Module: 'Personal'
          };

          this.personalService.postContractPersonalInfoId(this.contractSelected.ContractId, this.contractSelected.PersonalContractId,
            personalUpdateModel).subscribe((rest: any) => {
              this.flagChangeContratista = false;

              if (rest?.CarnetCode === null || rest?.CarnetCode === undefined) {
                this.flagChangeContratista = false;
              }

              if (this.dateSocialSecurityUpload.length !== 0 || this.replaceEPSorAFPdata.length !== 0) {
                for (let index = 0; index < this.dateSocialSecurityUpload.length; index++) {
                  if (this.dateSocialSecurityUpload[index].Model === 'EmployerPersonalRequirement') {
                    this.personalService.putEmployerPersonalRequirement(this.dateSocialSecurityUpload[index].Id,
                      { ...this.dateSocialSecurityUpload[index], Module: 'Personal' }).subscribe(() => {
                        if (index === this.dateSocialSecurityUpload.length - 1) {
                          this.generateDocumentComentant();
                        }
                      });
                  } else if (this.dateSocialSecurityUpload[index].Model === 'PersonalRequirement') {
                    this.personalService.putPersonalRequirement(this.dateSocialSecurityUpload[index].Id,
                      { ...this.dateSocialSecurityUpload[index], Module: 'Personal' }).subscribe(() => {
                        if (index === this.dateSocialSecurityUpload.length - 1) {
                          this.generateDocumentComentant();
                        }
                      });
                  } else if (this.dateSocialSecurityUpload[index].Model === undefined) {
                    this.personalService.putPersonalRequirementPlanilla(this.dateSocialSecurityUpload[index].Id, this.personalCompanyInfoId,
                        this.contractSelected.EmployerId, this.dateSocialSecurityUpload[index].Date).subscribe(() => {
                        if (index === this.dateSocialSecurityUpload.length - 1) {
                          this.generateDocumentComentant();
                        }
                      });
                  }
                }

                for (let index = 0; index < this.replaceEPSorAFPdata.length; index++) {
                  this.personalService.changeEpsAFpPATCH(this.contractsOffline[this.indexSelect].PersonalGuidId,
                    this.replaceEPSorAFPdata[index].path, this.replaceEPSorAFPdata[index].value).subscribe(() => {
                      if (index === this.replaceEPSorAFPdata.length - 1) {
                        this.replaceEPSorAFPdata = [];
                        this.getContractPersonal();
                        this.getRefrestHistory();
                        this.getPersonalInfoId();
                      }
                    });
                }
              } else {
                if (this.changeEmployerId === true && this.employerChangeDocument.EmployerId !== this.formVigencia.get('EmployerId').value
                ) {
                  this.dialogService.openDialogConfirm('¿Desea copiar los documentos del empleado ' +
                      this.employerChangeDocument.EmployerName + ' al empleador ' + this.formVigencia.get('EmployerName').value + '?',
                      true, true, 'NO', 'SI')
                    .afterClosed().subscribe(restDialog => {
                      if (restDialog !== false) {
                        const transferModel = {
                          personalCompanyInfo: this.personalId as number,
                          prevEmployer: this.employerChangeDocument.EmployerId,
                          newEmployer: this.formVigencia.get('EmployerId').value,
                          Module: 'Personal'
                        };
                        this.personalService.postTransferDocumentRequirement(transferModel).subscribe(() => {
                          this.changeEmployerId = false;
                          this.getContractPersonal();
                          this.getPersonalInfoId();
                          this.getRefrestHistory();
                        });
                      } else {
                        this.getContractPersonal();
                        this.getRefrestHistory();
                        this.getPersonalInfoId();
                      }
                    });
                } else {
                  this.getContractPersonal();
                  this.getRefrestHistory();
                  if (this.contractSelected?.ContractId) {
                    this.refreshContractsView(this.contractSelected.ContractId);
                  }
                  this.updateBannerFromData();
                }
              }
            });
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.dialogService.openDialogMovePersonalInfo(true, error, 'Desea trasladarlo?',
              false).afterClosed().subscribe(restDialog => {
                if (restDialog === true) {
                  const pesonalCompany = {
                    AfpId: this.formPersonal.get('AfpId').value,
                    ContractId: this.contractSelected.ContractId,
                    EmployerId: null,
                    EpsId: this.formPersonal.get('EpsId').value,
                    PersonalCompanyInfoId: this.personalId,
                    Position: this.formVigencia.get('Position').value,
                    TypeARL: this.formVigenciaArlExigida.get('TypeARL').value,
                    StartDate: this.formVigencia.get('StartDateContract').value,
                    FinishDate: this.formVigencia.get('FinishDateContract').value,
                    tillEndOfDay: false,
                    Module: 'Personal'
                  };
                  this.contractService.postMovePersonalInfoContract(this.contractSelected.ContractId, pesonalCompany).subscribe(() => {
                      this.getRefrestHistory();
                    });
                }
              });
          }
        }
      );
    setTimeout(() => {
      this.flagChangeDataBtnSave = false;
      this.changeAfterfillFormPersonal = false;
      this.changeAfterfillFormVigenciaArlExigida = false;
      this.changeAfterfillFormVigencia = false;
      this.changeAfterfillFormPersonalCV = false;
      this.changeAfterfillFormVaccine = false;
      this.changeAfterfillFormContractIndividual = false;
      this.changeAfterfillFormOtrosDatos = false;
    }, 2000);
  }

  generateDocumentComentant() {
    if (this.dateSocialSecurityUpload.length !== 0) {
      for (let index = 0; index < this.dateSocialSecurityUpload.length; index++) {
        if (this.dateSocialSecurityUpload[index].Model === 'EmployerPersonalRequirement' ) {
            if (index === this.dateSocialSecurityUpload.length - 1) {
              if (this.changeEmployerId === true) {
                this.dialogService.openDialogConfirm('¿Desea copiar los documentos del empleado ' + this.employerChangeDocument.EmployerName
                  + ' al empleador ' + this.formVigencia.get('EmployerName').value + '?', true, true,
                  'NO', 'SI').afterClosed().subscribe(restDialog => {
                  if (restDialog !== false) {
                    const model: ChangeTransferEMployerDocument = {
                      personalCompanyInfo: this.personalId,
                      prevEmployer: this.employerChangeDocument.EmployerId,
                      newEmployer: this.formVigencia.get('EmployerId').value,
                      Module: 'Personal',
                    };
                    this.personalService.postTransferDocumentRequirement(model).subscribe(rest => {
                      this.changeEmployerId = false;
                      this.getContractPersonal();
                      this.getPersonalInfoId();
                      this.dateSocialSecurityUpload = [];
                    });
                  } else {
                    this.getContractPersonal();
                    this.getPersonalInfoId();
                    this.dateSocialSecurityUpload = [];
                  }
                });
              } else {
                this.getContractPersonal();
                this.getPersonalInfoId();
              }
            }
        } else if (this.dateSocialSecurityUpload[index].Model === 'PersonalRequirement') {
            if (index === this.dateSocialSecurityUpload.length - 1) {
              if (this.changeEmployerId === true) {
                this.dialogService.openDialogConfirm('¿Desea copiar los documentos del empleado ' + this.employerChangeDocument.EmployerName
                  + ' al empleador ' + this.formVigencia.get('EmployerName').value + '?', true, true,
                  'NO', 'SI').afterClosed().subscribe(restDialog => {
                  if (restDialog !== false) {
                    const model: ChangeTransferEMployerDocument = {
                      personalCompanyInfo: this.personalId,
                      prevEmployer: this.employerChangeDocument.EmployerId,
                      newEmployer: this.formVigencia.get('EmployerId').value,
                      Module: 'Personal',
                    };
                    this.personalService.postTransferDocumentRequirement(model).subscribe(rest => {
                      this.changeEmployerId = false;
                      this.getContractPersonal();
                      this.getPersonalInfoId();
                      this.dateSocialSecurityUpload = [];
                    });
                  } else {
                    this.getContractPersonal();
                    this.getPersonalInfoId();
                    this.dateSocialSecurityUpload = [];
                  }
                });
              } else {
                this.getContractPersonal();
                this.getPersonalInfoId();
                this.dateSocialSecurityUpload = [];
              }
            }
        }
      }
    } else {
      if (this.changeEmployerId === true) {
        this.dialogService.openDialogConfirm('¿Desea copiar los documentos del empleado ' + this.employerChangeDocument.EmployerName + ' al empleador ' + this.formVigencia.get('EmployerName').value + '?', true, true, 'NO', 'SI').afterClosed().subscribe(restDialog => {
          if (restDialog !== false) {
            const model: ChangeTransferEMployerDocument = {
              personalCompanyInfo: this.personalId,
              prevEmployer: this.employerChangeDocument.EmployerId,
              newEmployer: this.formVigencia.get('EmployerId').value,
              Module: 'Personal',
            };
            this.personalService.postTransferDocumentRequirement(model).subscribe(rest => {
              this.changeEmployerId = false;
              this.getContractPersonal();
              this.getPersonalInfoId();
              this.dateSocialSecurityUpload = [];
            });
          }
        });
      }
    }

  }

  postVaccice() {
    let model;
    if (this.getDescriptionStatus(this.formVaccine.get('VaccineStatusId').value) === 'Vacunado' || this.getDescriptionStatus(
      this.formVaccine.get('VaccineStatusId').value) === 'Parcialmente Vacunado') {
      model = {
        PersonalCompanyInfoId: this.personalId,
        VaccineStatusId: this.formVaccine.get('VaccineStatusId').value,
        VaccineTypeId: this.formVaccine.get('VaccineTypeId').value,
        AppliedDose: this.formVaccine.get('AppliedDose').value,
        VaccineObservations: this.formVaccine.get('VaccineObservations').value,
        Module: 'Personal'
      };
    } else {
      model = {
        PersonalCompanyInfoId: this.personalId,
        VaccineStatusId: this.formVaccine.get('VaccineStatusId').value,
        VaccineObservations: this.formVaccine.get('VaccineObservations').value,
        Module: 'Personal'
      };
    }
    this.personalService.postVaccine(model).subscribe((rest: any) => {
      this.personalStatus = rest?.VaccineStatus?.Description;
    });
  }

  putPersonalFull() {
    if (this.formPersonal.status === 'VALID' && this.formPersonalCV.status === 'VALID') {
      let birthDate: string;
      if (typeof this.formPersonal.get('BirthDate').value === 'object') {
        birthDate = this.fechasService.getDateFormatDayMontYear(this.formPersonal.get('BirthDate').value);
      } else {
        birthDate = this.formPersonal.get('BirthDate').value.toString().replace(/-/g, '').substr(0, 8);
      }
      const modelPersonalPut = {
        ...this.personal,
        Nationality: parseInt(this.formPersonal.get('Nationality').value, 10),
        DocumentNumber: this.formPersonal.get('DocumentNumber').value,
        DocumentType: this.formPersonal.get('DocumentType').value,
        Name: (this.formPersonal.get('Name')?.value || '').toString().toUpperCase(),
        LastName: (this.formPersonal.get('LastName')?.value || '').toString().toUpperCase(),
        BirthDate: birthDate,
        Sex: this.formPersonal.get('Sex').value,
        RH: this.formPersonal.get('RH').value,
        CityCode: this.formPersonal.get('CityCode').value,
        EmergencyContact: this.formPersonal.get('EmergencyContact').value,
        EmergencyContactPhone: this.formPersonal.get('EmergencyContactPhone').value,
        RelationshipWithContact: this.formPersonal.get('RelationshipWithContact').value,
        Address: this.formPersonal.get('Address').value,
        PhoneNumber: this.formPersonal.get('PhoneNumber').value,
        Email: (this.formPersonal.get('Email')?.value || '').toString().toLowerCase(),
        CityBirthCode: this.formPersonal.get('CityOfBirthCode').value,
        AfpId: this.formPersonal.get('AfpId').value,
        EpsId: this.formPersonal.get('EpsId').value,
        TownId: this.formPersonal.get('TownId').value,
        JobCode: this.formPersonalCV.get('JobCode').value,
        MaritalStatusId: this.formPersonalCV.get('MaritalStatusId').value,
        NumberOfChilds: this.formPersonalCV.get('NumberOfChilds').value,
        NumberOfDependants: this.formPersonalCV.get('NumberOfDependants').value,
        SocialStratumId: this.formPersonalCV.get('SocialStratumId').value,
        Medicines: this.formPersonalCV.get('Medicines').value,
        ExpeditionDate: this.controlExpeditionDate.value ? this.controlExpeditionDate.value : null,
        ExpeditionPlaceCode: this.controlExpeditionPlace.value ? this.controlExpeditionPlace.value : null,
        Module: 'Personal'
      };
      this.personalService.putPersonalFull(this.personalId, modelPersonalPut).subscribe(restPersonal => {
        const modelPersonalCV = {
          PersonalCompanyInfoId: this.personalId,
          EducationalLevelId: this.formPersonalCV.get('EducationalLevelId').value,
          ExperienceYears: this.formPersonalCV.get('ExperienceYears').value,
          ExperienceMonths: this.formPersonalCV.get('ExperienceMonths').value,
          Module: 'Personal'
        };
        this.personalService.postPersonalCV(modelPersonalCV).subscribe((restPOSTPersonalCV: any) => {
          if ((this.urlDataStudyCertificate === null || this.urlDataStudyCertificate === '')
            && this.formDataStudyCertificate !== undefined){
            this.personalService.updatePhotoAddStudyCertificate(restPOSTPersonalCV.Id,
              this.formDataStudyCertificate).subscribe(restUpdateFileStudy => {
            });
          }
          if ((this.urlDataExperienceCertificate === null || this.urlDataExperienceCertificate === '')
            && this.formDataExperienceCertificate !== undefined){
            this.personalService.updatePhotoAddExperienceCertificate(restPOSTPersonalCV.Id,
              this.formDataExperienceCertificate).subscribe(restUpdateFileStudy => {
            });
          }
          this.indexSelect = 0;
          this.snackBService.openSuccess('Empleado actualizado correctamente', '', 3000);
        });
      });
    } else {
      this.snackBService.openWarning('Formulario del empleado incompleto', '', 3000);
    }
  }

   // Servicios antes de generar la Planilla
    getServices() {
      this.employerService.getSecurityReferences().subscribe(data => {
        this.securityReferences = data;
        this.eps = this.securityReferences
          .filter(x => x.Type === TypeSecurityReference.EPS && x.IsActive === true)
          .sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);

        this.afp = this.securityReferences
          .filter(x => x.Type === TypeSecurityReference.AFP && x.IsActive === true)
          .sort((a, b) => a.OrderNum > b.OrderNum ? 1 : -1);
      });

      forkJoin({
        occupationalRisk: this.commonServices.getCommonOptionsLocalOrApi('CoPs_OccupationalRisk'),
        bankAccountType:  this.commonServices.getCommonOptionsLocalOrApi('CoPs_BankAccountType'),
        dateLabel:        this.commonServices.getCommonOptionsLocalOrApi('CoPs_DateLabel'),
      }).subscribe(({ occupationalRisk, bankAccountType, dateLabel }) => {
        this.occupationalRisk = occupationalRisk;
        this.bankAccountType  = bankAccountType;
        this.dateLabel        = dateLabel;
      });

      this.contratingService.getBanks().subscribe((rest: any) => {
        this.bancks = rest;
      });

      this.getProjects();
    }

  etImg(logo) {
    return (logo === null ? 'assets/images/personblue.png' : logo);
  }

  disabledFormularios() {
    if ((this.flagListF === true || this.flagVeto === true)) {
      this.formVigenciaArlExigida.disable();
      this.formPersonalCV.disable();
      this.formVigencia.disable();
      this.formVaccine.disable();
      this.formPersonal.disable();
      this.formDatosContrato.disable();
      this.formOtrosDatos.disable();
    } else {
      this.formVigenciaArlExigida.enable();
      this.formPersonalCV.enable();
      this.formVigencia.enable();
      this.formVaccine.enable();
      this.formPersonal.enable();
      this.formDatosContrato.enable();
      this.formOtrosDatos.enable();
    }
  }

  certifIsValition(certif): boolean {
    let a = true;
    if (certif.Type === 'CCD' || certif.Type === 'PEP'){
      if (certif.Type === 'CCD' && this.formPersonal.get('Nationality').value !== '0'){
        a = false;
      }
      if (certif.Type === 'PEP' && this.formPersonal.get('Nationality').value === '0'){
        a = false;
      }
    }
    return a;
  }

  getContractPersonal() {
    const newPersonalCompany: PersonalContractProyect[] = [];
    this.personalService.getInfoPersonalCompanyPersonalId(this.personalCompanyInfoId, true).subscribe(
      (infoPersonalCompanyPersonalId: InfoPersonalCompanyPersonalId) => {
      // Formulario Personal
      this.personal = infoPersonalCompanyPersonalId;
      this.permissionsCompany = this.userAuth.Companies.find(x => x.Id === this.personal.CompanyInfoId).Permissions;
      this.getAllowNonCompliantWorkerActivation();

      this.fillFormPersonal();
        // fim formulario Personal
      this.infoPersonalCompanyPersonalId = infoPersonalCompanyPersonalId;
      this.checkPhotoQualityAndSyncRequestChange(this.personalCompanyInfoId);
      this.exitContractsOffline = false;

      setTimeout(() => {
        this.disabledFormsByPermissions();
      }, 1500);
      this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, true).pipe(take(1))
          .subscribe((contractsOffline: ContractsOffline[]) => {
            if (contractsOffline.length === 0) {
              // El personal no tiene contratos activos: cargar todos (incluyendo inactivos)
              // para no mostrar pantalla vacía y evitar crash en selectContract
              this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, false)
                .pipe(take(1)).subscribe(allContracts => {
                  this.inactiveContractsLoaded = true;
                  this.hasActiveContracts = false;
                  this.processInitialContracts(allContracts);
                });
              return;
            }
            this.inactiveContractsLoaded = false;
            this.hasActiveContracts = true;
            this.processInitialContracts(contractsOffline);
          });
      });
  }

  validateActiveContracts(){
    this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, true).subscribe(
      (contractsOffline: ContractsOffline[]) => {
        this.hasActiveContracts = contractsOffline.length > 0;
      });
  }

  private processInitialContracts(contractsOffline: ContractsOffline[]): void {
    this.allContractsActiveInactive = contractsOffline;
    const acc: any[] = [];
    const arrayNewContractModifica: ContractsOffline[] = (contractsOffline || []).map((x: any) => ({
      ...x,
      Control: new FormControl()
    }));

    this.contracts = arrayNewContractModifica.sort((x: any, y: any) =>
        x.IsActive === true && y.Expiry === true && -new Date(x.FinishDate) + -new Date(y.FinishDate))
      .sort((a: any, b: any) => (a.IsActive === true && a.Expiry === true &&
        this.getCalculateStateDateFromIcon(a.FinishDate) === 'person-orange') ? -1 : (a.IsActive === true &&
        a.Expiry === false && this.getCalculateStateDateFromIcon(a.FinishDate) === 'person-blue' ? -1 : 1)
      );

    this.configContractOffice(this.indexSelect, contractsOffline);

    contractsOffline.forEach((pc: any) => {
      JSON.parse(pc.ProjectContracts).forEach((p: ProjectContracts) => {
        acc.push({ PersonalProyect: p, PersonalContract: pc });
      });
    });

    this.personalContractProyect = acc.sort((x: any, y: any) => x.PersonalContract.IsActive === true &&
        y.PersonalContract.Expiry === true && -new Date(x.PersonalContract.FinishDate) + -new Date(y.PersonalContract.FinishDate))
      .sort((a: any, b: any) =>
        (a.PersonalContract.IsActive === true && a.PersonalContract.Expiry === true &&
          this.getCalculateStateDateFromIcon(a.PersonalContract.FinishDate) === 'person-orange') ? -1
          : (a.PersonalContract.IsActive === true && a.PersonalContract.Expiry === false &&
            this.getCalculateStateDateFromIcon(a.PersonalContract.FinishDate) === 'person-blue') ? -1 : 1
      );
    if (this.hasActiveContracts) {
      this.filterContracts   = this.prioritizeContracts(arrayNewContractModifica);
      this.rebuildAllUnique();
      this.onlyInactivesMode     = false;
      this.showOnlyActive        = true;
      this.showOnlyInactiveBanner = false;
    } else {
      this.filterContracts   = this.prioritizeContracts(arrayNewContractModifica);
      this.rebuildAllUnique();
      this.onlyInactivesMode      = true;
      this.showOnlyActive         = true;
      this.showOnlyInactiveBanner = true;
    }
    setTimeout(() => {
      this.changeAfterfillFormVigenciaArlExigida = true;
      this.changeAfterfillFormVigencia = true;
      this.changeAfterfillFormPersonalCV = true;
      this.changeAfterfillFormVaccine = true;
      this.changeAfterfillFormContractIndividual = true;
      this.changeAfterfillFormOtrosDatos = true;
      if (this.requestService.dataContract !== undefined) {
        this.associateContrac(this.requestService.dataContract);
      }
    }, 2000);
    this.selectContract(this.indexSelect, true);
    this.afterInitialContractsLoad();
  }

  disabledFormsByPermissions(){
    if (!this.exitPermissionCompany('personalsemployercontract.update')){
      this.formDatosContrato.disable();
    }
    if (!this.exitPermissionCompany('personals.update')) {
      this.disabledByPermissionUpdate = true;
      this.formPersonal.disable();
      this.formPersonalCV.disable();
      this.formVigencia.disable();
      this.formVaccine.disable();
    }
  }

  putIndividualContractLabor(onContinue?: () => void) {
    if (this.formDatosContrato.get('EndDate').value === 'NaN-0NaN-0NaNT00:00:00') {
      this.formDatosContrato.get('EndDate').setValue(null);
    }
    if (this.formDatosContrato.get('StartDate').value === 'NaN-0NaN-0NaNT00:00:00') {
      this.formDatosContrato.get('StartDate').setValue(null);
    }
    if (this.exitPersonalEmployerByPersonalPOSTPUT !== undefined) {
      const model = {
        Salary: this.formDatosContrato.get('Salary').value?.toString()?.replace(/\$/g, '')?.replace(/\./g, ''),
        StartDate: this.formDatosContrato.get('StartDate').value,
        EndDate: this.formDatosContrato.get('EndDate').value,
        PositionName: this.formDatosContrato.get('PositionName').value,
        BankAccount: this.formDatosContrato.get('BankAccount').value,
        ContractNumber: this.formDatosContrato.get('ContractNumber').value,
        ContractTypeId: this.formDatosContrato.get('ContractTypeId').value,
        BankId: this.formDatosContrato.get('BankId').value,
        BankAccountTypeId: this.formDatosContrato.get('BankAccountTypeId').value,
        TransportationAllowance: this.formDatosContrato.get('AuxiliaryTransport').value?.toString()?.replace(/\$/g, '')?.replace(/\./g, ''),
        TotalEarnings: this.formDatosContrato.get('TotalEarnings').value?.toString()?.replace(/\$/g, '')?.replace(/\./g, ''),
        IsActive: true,
        // IMPORTAN
        EmployerInfoId: this.formDatosContrato.get('EmployerInfoId').value,
        PersonalCompanyInfoId: this.personalCompanyInfoId,
        // datos pre nomina
        WorkShiftId: this.formDatosContrato.get('WorkShiftId').value,
        HasExtraTime: this.formDatosContrato.get('HasExtraTime').value,
        ProjectId: this.formDatosContrato.get('ProjectId').value,
        Module: 'Personal'
      };
      if (this.contractLaborSelected !== undefined) {
        this.personalService.putPersonalEmployer(this.contractLaborSelected.Id, model).subscribe(postPersonalEmployer => {
          this.hasExtraTimeChangeSnapshot = null;
          this.projectChangeSnapshot = null;
          onContinue?.();
        }, (error: HttpErrorResponse) => {
          if (error.status === 418) {
            const message = error.error?.Error || error.error?.Message || 'Tiene horas pendientes por aprobar';
            this.snackBService.openWarning(message, '', 5000);
            this.revertHasExtraTimeChange();
            this.revertProjectChange();
            this.flagChangeDataBtnSave = false;
            return;
          }
          onContinue?.();
        });
        return;
      }
    }
    onContinue?.();
  }

  // FLujo Contrato individual
  postIndividualContractLabor(): void {
    this.dialogService.openDialogSelectedControlSearchList({ textInput: 'Seleccione empleador', isCard: false,
        isCardImage: false, dataShow: 'Name', otherFilter: 'DocumentNumber', dataValue: 'Id', isDescription: true },
        'CONTRATO LABORAL', this.allEmployers, true, false, false, '', 'GUARDAR')
      .afterClosed().subscribe(selectedEmployerId => {
        if (selectedEmployerId !== false) {
          this.personalService.getPersonalEmployerByPersonalAndEmployer(this.personalCompanyInfoId, selectedEmployerId).subscribe(
              (restExitContract: any) => {this.snackBService.openWarning('Ya existe un contrato laboral con el empleador ' +
                restExitContract.EmployerName, '', 4000);
              },
              error => {
                this.dialogService.openDialogCreateContractLabor(this.personalCompanyInfoId, selectedEmployerId,
                  this.personal.CompanyInfoId, this.companyIdUserLogin).afterClosed().subscribe(dialogResult => {
                    if (dialogResult !== false) {
                      this.getPersonalEmployerInfoExit();
                    }
                  });
              }
            );
        }
      });
  }

  getIndividualContractsType() {
    forkJoin({
      individualContractsType: this.commonServices.getCommonOptionsLocalOrApi('CoPs_IndividualContractsType'),
      states:                  this.commonServices.getCommonOptionsLocalOrApi('CoPs_IndividualContractsStageType'),
    }).subscribe(({ individualContractsType, states }) => {
      this.individualContractsType = individualContractsType;
      this.states                  = states;
    });
  }

  deleteContractLabor(Id, ContractNumber) {
    if (Id !== null) {
      this.dialogService.openDialogConfirm('¿Esta seguro de eliminar el contrato laboral ' +
        (ContractNumber === null ? '?' : ContractNumber + '?')).afterClosed().subscribe((result: DialogDataConfirm) => {
        if (result.confirm === true) {
          this.personalService.deletePersonalEmployer(Id).subscribe(restDelete => {
            this.getPersonalEmployerInfoExit();
          });
        }
      });
    }
  }

  getPositionEmployerId(CompanyId) {
    this.employerService.getPositionEmployerId(CompanyId).subscribe((positions: Positions[]) => {
      this.positionsIndividualContract = positions;
    });
  }

  changePositionsIndividualContract() {
    const data: any = this.personal.Employers.find((x: any) => x.EmployerId === this.contractSelected.EmployerId);
    if (data !== undefined) {
      this.getPositionEmployerId(data.CompanyId);
      this.getCCFList(data.CompanyId);
    }
  }

  getCCFList(CompanyId) {
    this.employerService.getAddCCFemployerId(CompanyId).subscribe((ccfList: any[]) => {
      this.ccf = ccfList;
    });
  }

  getPersonalEmployerInfoExit(): void {
    const data: any = this.personal.Employers.find((x: any) => x.EmployerId === this.contractSelected.EmployerId);
    if (data === undefined) { return; }
    this.setLoadingLabor(true);
    this.personalService.getPersonalEmployerByPersonal(this.personalCompanyInfoId, false, null).subscribe(
      (exitPersonalEmployerinfo: any) => {
          if (exitPersonalEmployerinfo !== null && exitPersonalEmployerinfo !== undefined) {
            const arrayNewContractLaborModifica: any[] = [];

            exitPersonalEmployerinfo.forEach((x: any) => {
              if (x.Salary !== 0 && x.Salary !== null && x.Salary !== undefined) {
                x.Salary = this.currencyPipe.transform(x.Salary.toString().replace(/\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.0-0')
                  .replace(/,/gi, '.');
              }
              if (x.TransportationAllowance !== 0 && x.TransportationAllowance !== null && x.TransportationAllowance !== undefined) {
                x.TransportationAllowance = this.currencyPipe.transform(x.TransportationAllowance.toString().replace(/\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.0-0')
                  .replace(/,/gi, '.');
              }

              arrayNewContractLaborModifica.push({
                ...x,
                ControlEmployerInfoId: new FormControl(x.EmployerInfoId),
                ControlContractTypeId: new FormControl(x.ContractTypeId),
                ControlBankId: new FormControl(x.BankId),
                ControlBankAccountTypeId: new FormControl(x.BankAccountTypeId),
                ControlProjectId: new FormControl(x.ProjectId),
                ControlWorkShift: new FormControl(x.WorkShiftId),
                ControlHasExtraTime: new FormControl(x.HasExtraTime),
                workShiftList: [],
              });
            });

            this.contractsLabor = arrayNewContractLaborModifica;
            this.showOnlyActiveLabor = true;
            if (exitPersonalEmployerinfo.length !== 0) {
              this.formDatosContrato.get('ContractTypeId').setValue(exitPersonalEmployerinfo[0].ContractTypeId);
              this.formDatosContrato.get('ContractNumber').setValue(exitPersonalEmployerinfo[0].ContractNumber);
              this.formDatosContrato.get('EmployerInfoId').setValue(exitPersonalEmployerinfo[0].EmployerInfoId);
              this.formDatosContrato.get('EmployerName').setValue(exitPersonalEmployerinfo[0].EmployerName);
              this.formDatosContrato.get('EmployerDocumentNumber').setValue(exitPersonalEmployerinfo[0].EmployerDocumentNumber);
              this.formDatosContrato.get('EmployerDocumentType').setValue(exitPersonalEmployerinfo[0].EmployerDocumentType);
              this.formDatosContrato.get('EmployerLogo').setValue(exitPersonalEmployerinfo[0].EmployerLogo);
              this.formDatosContrato.get('PositionName').setValue(exitPersonalEmployerinfo[0].PositionName);
              this.formDatosContrato.get('Salary').setValue(
                exitPersonalEmployerinfo[0].Salary === 0 ? 0 : exitPersonalEmployerinfo[0].Salary
              );
              this.formDatosContrato.get('AuxiliaryTransport').setValue(
                exitPersonalEmployerinfo[0].TransportationAllowance === 0 ? 0 : exitPersonalEmployerinfo[0].TransportationAllowance
              );
              this.formDatosContrato.get('TotalEarnings').setValue(
                exitPersonalEmployerinfo[0].TotalEarnings === 0 ? 0 : exitPersonalEmployerinfo[0].TotalEarnings
              );

              // Datos bancarios
              this.formDatosContrato.get('BankAccount').setValue(exitPersonalEmployerinfo[0].BankAccount);
              this.formDatosContrato.get('BankId').setValue(exitPersonalEmployerinfo[0].BankId);
              this.formDatosContrato.get('BankAccountTypeId').setValue(exitPersonalEmployerinfo[0].BankAccountTypeId);
              this.formDatosContrato.get('ProjectId').setValue(exitPersonalEmployerinfo[0].ProjectId);
              this.formDatosContrato.get('WorkShiftId').setValue(exitPersonalEmployerinfo[0].WorkShiftId);
              this.formDatosContrato.get('HasExtraTime').setValue(exitPersonalEmployerinfo[0].HasExtraTime);
              this.exitPersonalEmployerByPersonalPOSTPUT = exitPersonalEmployerinfo;
            } else {
              // Sin data
              this.formDatosContrato.get('PositionName').setValue('');
              this.formDatosContrato.get('Salary').setValue(0);
              this.formDatosContrato.get('StartDate').setValue('');
              this.formDatosContrato.get('EndDate').setValue('');
            }

            this.rebuildVisibleLaborContractsSorted();

            setTimeout(() => {
              this.changeAfterfillFormContractIndividual = true;
            }, 3000);
          } else {
            // Sin data
            this.formDatosContrato.get('PositionName').setValue('');
            this.formDatosContrato.get('Salary').setValue(0);
            this.formDatosContrato.get('StartDate').setValue('');
            this.formDatosContrato.get('EndDate').setValue('');
            this.contractsLabor = [];
            this.rebuildVisibleLaborContractsSorted();
          }
          this.selectContractLabor(this.indexSelectContracLabor, true);
          this.setLoadingLabor(false);
        },
        error => {
          this.formDatosContrato.get('PositionName').setValue('');
          this.formDatosContrato.get('Salary').setValue(0);
          this.formDatosContrato.get('StartDate').setValue('');
          this.formDatosContrato.get('EndDate').setValue('');
          this.exitPersonalEmployerByPersonalPOSTPUT = false;
          this.rebuildVisibleLaborContractsSorted();
          this.setLoadingLabor(false);
        }
      );
  }

    // FLujo Contrato individual FIjn
  getNamesProyect(Proyects: string): any[] {
    const project = [];
    const parseo = JSON.parse(Proyects);
    parseo.forEach(element => {
        this.infoPersonalCompanyPersonalId.Projects.forEach(info => {
          if (element.ProjectId === info.ProjectId) {
            project.push({Name: info.Name, FinishDate: info.FinishDate});
          }
        });
      });
    return project;
  }

  getLastStageId(): number {
    let idStage = 0;
    this.lastStages.forEach((stage: CommonOptions) => {
      if (stage.Value === 'INI') {
        idStage = stage.Id;
      }
    });
    return idStage;
  }

  getLastStages() {
    this.commonServices.getCommonOptionsLocalOrApi('CoPs_PersonalContractStage').subscribe(data => {
      this.lastStages = data;
    });
  }

  startRetiro(contrato, i) {
    this.changeSelectedContractLabor(i);
    const flagEmpty = true;

    if (this.formDatosContrato.get('Salary').value === 0 ||
      this.formDatosContrato.get('Salary').value === null ||
      this.formDatosContrato.get('Salary').value === undefined ||
      this.formDatosContrato.get('Salary').value === '' ||
      this.formDatosContrato.get('AuxiliaryTransport').value === 0 ||
      this.formDatosContrato.get('AuxiliaryTransport').value === null ||
      this.formDatosContrato.get('AuxiliaryTransport').value === undefined ||
      this.formDatosContrato.get('AuxiliaryTransport').value === '') {
      this.snackBService.openWarning('DILIGENCIAR EL CAMPO DE SALARIO Y AUXILIO DE TRANSPORTE', '', 4000);
      return;
    }
    this.getLastStages();
    this.companiesService.getPersonalTerminationRequestTerminationType(this.userAuth.Companies[0].Id).subscribe(types => {
      this.dialogService.openDialogSelectedControlWithdrawal({textInput: '', isCard: false, isCardImage: false, dataShow: 'Name',
          otherFilter: 'Description', dataValue: 'Id', isDescription: true},
        'SELECCIONE TIPO DE RETIRO', types.filter(x => x.IsActive === true),
        true, true, true, 'Cancelar', 'Iniciar',
        true, 'Al iniciar esta solicitud, se inhabilitara el acceso del empleado en los proyectos.', 'RED',
        this.visibleLaborContractsSorted[this.indexSelectContracLabor].EndDate
      ).afterClosed().subscribe(rest => {
        if (rest !== false) {
          const endDate = rest.checkbox1 ? null : rest.secondDate;
          const model = {
            PersonalEmployerId: contrato.Id,
            TerminationStateId: this.getLastStageId(),
            TerminationTypeId: rest.controlSelected,
            TerminationDate: this.fechasService.getDateFormatDatePikerDATEHORANOW(),
            UsePersonalEmployerEndDate: rest.checkbox1,
            EndOfAccessDate: endDate,
            LastComment: rest.commentary,
            removeAccess: true,
            Module: 'Personal'
          };
          this.terminationService.postPersonalTerminationRequest(model, false).subscribe((restExitContract: any) => {
            this.snackBService.openSuccess('Solicitud creada correctamente!', '', 4000);
            this.requestId(restExitContract.PersonalCompanyInfoId, restExitContract.Id);
          }, (error: HttpErrorResponse) => {
            if (error.status === 418) {
              // Se utilizará el redireccionamiento si existe la solicitud de retiro.
              this.dialogService.openDialogConfirm('Ya existe una solicitud de retiro en trámite', true, true,
                  'CERRAR', 'ABRIR SOLICITUD').afterClosed().subscribe(dialogResult => {
                  if (dialogResult !== false) {
                    this.requestId(error.error.PersonalCompanyInfoId, error.error.PersonalTerminationRequestId);
                  }
                });
            }
          });
        }
      });
    });
  }

  requestId(PersonalCompanyInfoId, IdRequest) {
    if (this.commonMetodService._getExitPermissionModel('termination') === true) {
      this.router.navigate(['/admin/termination/termination', PersonalCompanyInfoId , IdRequest]);
    }

  }

  getContractsOffline(indexSelect) {
    this.exitContractsOffline = false;
    // Use onlyActive=false when the selected contract is inactive or inactive contracts are already loaded,
    // to ensure the selected contract can be found in configContractOffice and the documents section stays visible.
    const onlyActive = !this.inactiveContractsLoaded && (this.contractSelected?.IsActive !== false);
    this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, onlyActive).subscribe(
      (contractsOffline: ContractsOffline[]) => {
        if (!onlyActive) {
          this.allContractsActiveInactive = contractsOffline;
        }
        this.configContractOffice(indexSelect, contractsOffline, this.contractSelected);
      });
  }

  configContractOffice(indexSelect, contractsOffline: ContractsOffline[], contractSelected?) {
    this.contractsOffline = contractsOffline;
    this.exitContractsOffline = true;
    if (contractSelected !== undefined) {
      const contractSeletedData = contractsOffline.find(x => x.ContractId === contractSelected.ContractId);
      if (!contractSeletedData) { return; }
      const biometricAge = contractSeletedData?.Reqs?.Biometric?.[0];
      this.min = biometricAge?.MinValue;
      this.max = biometricAge?.MaxValue;
      this.biometricMaxMin = this.min + ' ≤ Edad < ' + this.max;
      const edad = this.fechasService.calcularEdad(this.fechasService.formatBirthDate(contractSeletedData?.BirthDate));
      // El backend no valida realmente el rango de edad en Biometric[0].IsValided, por eso se calcula aqui.
      // El límite superior es exclusivo (Edad < max), igual que el texto mostrado en biometricMaxMin.
      // Si el contrato no tiene requisito de edad configurado, no se restringe por edad.
      this.edadRange = !biometricAge ? true : (edad >= this.min && edad < this.max);
      this.socialSecurity = [];
      this.certification = [];
      this.socialSecurity = contractSeletedData.Reqs.SocialSecurity;
      this.certification = contractSeletedData.Reqs.Certification;
      this.surveys = contractSeletedData.Reqs.Surveys;
      this.entry = contractSeletedData.Reqs.Entry;

      // Reset: Id/RequirementId de SocialSecurity es un catalogo compartido (EPS=2, ARL=3, AFP=4) entre
      // todos los contratos, por lo que sin este reset el guard de mas abajo conservaba la fecha del
      // primer contrato cargado en la sesion en vez de la del contrato seleccionado actualmente.
      this.docsUploadIniadoSocialSecurity = [];
      this.loadCCFPersonal(this.personalCompanyInfoId, contractSeletedData.EmployerId);
      this.socialSecurity.forEach(x => {
        if (this.exitDocumentDocsUploadIniadoSocialSecurity(x.Id) === false) {
        this.docsUploadIniadoSocialSecurity.push(
          { Date: x.ValidityDate,
            Id: x.Id,
            Model: 'EmployerPersonalRequirement',
            TypeARL: x.TypeARL
          });
        }
      });
      this.certification.forEach(x => {
        if (this.exitDocumentDocsUploadIniadoSocialSecurity(x.Id) === false) {
        this.docsUploadIniadoSocialSecurity.push(
          { Date: x.Date,
            Id: x.Id,
            Model: 'PersonalRequirement'
          });
        }
      });
      this.surveys.forEach(x => {
        if (this.exitDocumentDocsUploadIniadoSocialSecurity(x.SurveyId) === false) {
        this.docsUploadIniadoSocialSecurity.push(
          { Date: x.Date,
            Id: x.SurveyId,
            Model: 'PersonalRequirement'
          });
        }
      });
      this.entry.forEach(x => {
        if (this.exitDocumentDocsUploadIniadoSocialSecurity(x.Id) === false) {
        this.docsUploadIniadoSocialSecurity.push(
          { Date: '',
            Id: x.Id,
            Model: 'PersonalRequirement'
          });
        }
      });
      this.controEps.setValue(contractSeletedData.EpsId);
      this.controAfp.setValue(contractSeletedData.AfpId);
      this.controOccupationalRisk.setValue(contractSeletedData.Reqs?.TypeARL?.PersonalTypeARL);
      this.IsValidedARL = contractSeletedData.Reqs?.TypeARL?.IsValided;
      // HasDocuments del backend no contempla el rango de edad (Biometric.IsValided no refleja la edad real),
      // por lo que se combina aqui para que "ACCESO NO AUTORIZADO" y el boton Activar tambien lo tengan en cuenta.
      this.hasDocuments = contractSeletedData.HasDocuments === true && this.edadRange === true;
      this.isActive = contractSeletedData.IsActive;
    }
  }


  loadCCFPersonal(personalCompanyInfoId: any, EmployerInfoId: any): void {
    this.employerService
      .getEmployerPersonalCCF(personalCompanyInfoId, EmployerInfoId)
      .subscribe({
        next: (contractsCCF: any) => {
          this.controlCCF.setValue(contractsCCF.CCFId);
          this.ccfName = contractsCCF?.Name;
        },
        error: () => {
          this.controlCCF.setValue(null);
          this.ccfName = '';
        }
      });
  }

  exitDocumentDocsUploadIniadoSocialSecurity(Id: any): boolean {
    let exit = false;
    const data = this.docsUploadIniadoSocialSecurity.find(x => x.Id === Id);
    if (data !== undefined) {
      exit = true;
    }
    return exit;
  }

  exitDocumentDateSocialSecurityUpload(Id: any): boolean {
    let exit = false;
    const data = this.dateSocialSecurityUpload.find(x => x.Id === Id);
    if (data !== undefined) {
      exit = true;
    }
    return exit;
  }

  getshowDocumentos(data, color): string {
    let operatordocument: string;
    if (this.flagListF === true || this.flagVeto === true){
      if (color === 'negro') {
        operatordocument = 'file-negro-ojo';
      } else {
        operatordocument = 'file-rojo-ojo';
      }
      return operatordocument;
    }
    if (this.exitPermissionCompany('personalsrequirements.updatebyposition') && !this.exitPermissionCompany('personaldocument.delete') &&
      ((data.Model !== undefined || this.getCalculateStateDate(this.getDateDocsUploadIniadoSocialSecurity(data.Id)) === 'DateRed'))
      && (data.Model !== 'EmployerRequirement')) {
      // operatordocument = 'showUpdate';
      if (color === 'negro') {
        operatordocument = 'file-negro';
      } else {
        operatordocument = 'file-rojo';
      }
    } else if (this.exitPermissionCompany('personaldocument.delete') && (data.Model !== undefined ||
        this.getCalculateStateDate(this.getDateDocsUploadIniadoSocialSecurity(data.Id)) === 'DateRed')
      && (data.Model !== 'EmployerRequirement')) {
      // operatordocument = 'showDelete';
      if (color === 'negro') {
        operatordocument = 'file-negro';
      } else {
        operatordocument = 'file-rojo';
      }
    } else {
      // operatordocument = 'show';
      if (color === 'negro') {
        operatordocument = 'file-negro-ojo';
      } else {
        operatordocument = 'file-rojo-ojo';
      }
    }

    if (!this.exitPermissionCompany('personalsrequirements.updatebyposition')){
      if (color === 'negro') {
        operatordocument = 'file-negro-ojo';
      } else {
        operatordocument = 'file-rojo-ojo';
      }
    }
    return operatordocument;
  }

  showDocumentos(data, reqName: string) {
    const Id = data.Id;
    const docs = data.DocsJSON;
    const docsShow: ModelDocumentsShow[] = [];
    if (docs !== undefined && docs !== null && docs !== '' && docsShow.length === 0) {
      const array = Object.entries(JSON.parse(docs));
      array.forEach((doc: any) => {
            docsShow.push({ name: doc[0], urlDoc: doc[1]});
      });
    }

    let operatordocument: string;
    if (this.exitPermissionCompany('personalsrequirements.updatebyposition') && !this.exitPermissionCompany('personaldocument.delete') &&
        ((data.Model !== undefined || this.getCalculateStateDate(this.getDateDocsUploadIniadoSocialSecurity(Id)) === 'DateRed')) &&
        (data.Model !== 'EmployerRequirement')) {
        operatordocument = 'showUpdate';
      } else if (this.exitPermissionCompany('personaldocument.delete') && (data.Model !== undefined ||
        this.getCalculateStateDate(this.getDateDocsUploadIniadoSocialSecurity(Id)) === 'DateRed') &&
        (data.Model !== 'EmployerRequirement')) {
        operatordocument = 'showDelete';
      } else {
        operatordocument = 'show';
      }
    if (!this.exitPermissionCompany('personalsrequirements.updatebyposition')) { operatordocument = 'show'; }
    if (this.flagListF === true || this.flagVeto === true){
      operatordocument = 'show';
    }
    this.dialogService.openDialogGestorImg('GESTOR DE DOCUMENTOS', docsShow, operatordocument, 0, undefined,
      true, data.Desc, this.permissionsCompany, true,
      this.personal?.CompanyInfoId, data).afterClosed().subscribe((restDialog: any) => {
      if (restDialog !== undefined) {

        const durationOptionId = restDialog?.durationOptionId ?? null;
        const baseDate: string | undefined = restDialog?.baseDate ?? undefined;
        const maxFileSize = 10 * 1024 * 1024;
        const isAllowed = (f: File) =>
          ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'].includes(f?.type) &&
          /\.(pdf|jpg|jpeg|png)$/i.test((f?.name || '').toLowerCase());

        if (restDialog.files?.length) {
          const tooBig = restDialog.files.filter((f: File) => f.size > maxFileSize);
          if (tooBig.length) {
            this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
            return;
          }

          const badFormat = restDialog.files.filter((f: File) => !isAllowed(f));
          if (badFormat.length) {
            this.snackBService.openWarning('Solo se permite subir archivos en formatos PDF, JPG, PNG.', '', 5000);
            return;
          }
        }

        const contractSeletedData = this.contractsOffline.find(x => x.ContractId === this.contractSelected.ContractId);
        if (data.Model === 'EmployerPersonalRequirement') {
          if (Object.keys(restDialog.DocsJSON).length !== 0) {
            const model = {
              DocsJSON: restDialog.DocsJSON,
              Id,
              Model: 'EmployerPersonalRequirement',
              Module: 'Personal'
            };
            this.personalService.putDELETEEmployerPersonalRequirement(Id, model).subscribe((restDelete: any) => {
              if (restDialog.files.length !== 0){
                for (let i = 0; i < restDialog.files.length; i++) {
                  const formData = new FormData();
                  if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                    formData.append('commentary', restDialog.commentary);
                  }
                  formData.append('File', restDialog.files[i]);
                  this.personalService.putUPDATEFILEEmployerPersonalRequirement(Id, formData, durationOptionId,
                    baseDate).subscribe((restUpdate: any) => {
                    if (i === restDialog.files.length - 1) {
                      if (reqName === 'SocialSecurity'){
                        contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      } else if (reqName === 'Certification'){
                        contractSeletedData.Reqs.Certification.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      }
                    }
                    this.getContractsOffline(this.indexSelect);
                  });
                }
              } else {
                if (reqName === 'SocialSecurity'){
                  contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                } else if (reqName === 'Certification'){
                  contractSeletedData.Reqs.Certification.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                }
              }
            });
          } else if (restDialog.files.length !== 0){
            for (let i = 0; i < restDialog.files.length; i++) {
              const formData = new FormData();
              if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                formData.append('commentary', restDialog.commentary);
              }
              formData.append('File', restDialog.files[i]);
              this.personalService.putUPDATEFILEEmployerPersonalRequirement(Id, formData, durationOptionId,
                baseDate).subscribe((restUpdate: any) => {
                if (i === restDialog.files.length - 1) {
                  if (reqName === 'SocialSecurity'){
                    contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  } else if (reqName === 'Certification'){
                    contractSeletedData.Reqs.Certification.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  }
                }
                this.getContractsOffline(this.indexSelect);
              });
            }
          } else if (restDialog.commentary !== '' && restDialog.commentary !== undefined || durationOptionId || baseDate) {
            this.requestService.putRequirementFileComment(data.RequirementId, this.personalCompanyInfoId, this.employerId,
              restDialog.commentary, durationOptionId,
              baseDate).subscribe((restUpdate: any) => {
              if (reqName === 'SocialSecurity'){
                contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                  if (data.Id === social.Id) {
                    social.DocsJSON = restUpdate.DocsJSON;
                  }
                });
              } else if (reqName === 'Certification'){
                contractSeletedData.Reqs.Certification.forEach(social => {
                  if (data.Id === social.Id) {
                    social.DocsJSON = restUpdate.DocsJSON;
                  }
                });
              }
              this.getContractsOffline(this.indexSelect);
            });
          }
        } else if (data.Model === 'PersonalRequirement') {
          if (Object.keys(restDialog.DocsJSON).length !== 0) {
            const model = {
              DocsJSON: restDialog.DocsJSON,
              Id,
              Model: 'PersonalRequirement',
              Module: 'Personal'
            };
            this.personalService.putDELETEPersonalRequirement(Id, model).subscribe((restDelete: any) => {
              if (restDialog.files.length !== 0){
                for (let i = 0; i < restDialog.files.length; i++) {
                  const formData = new FormData();
                  if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                    formData.append('commentary', restDialog.commentary);
                  }
                  formData.append('File', restDialog.files[i]);
                  this.personalService.putUPDATEFILEPersonalRequirement(Id, formData, durationOptionId,
                    baseDate).subscribe((restUpdate: any) => {
                    if (i === restDialog.files.length - 1) {
                      if (reqName === 'SocialSecurity'){
                        contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      } else if (reqName === 'Certification'){
                        contractSeletedData.Reqs.Certification.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      }
                    }
                    this.getContractsOffline(this.indexSelect);
                  });
                }
              } else {
                if (reqName === 'SocialSecurity'){
                  contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                } else if (reqName === 'Certification'){
                  contractSeletedData.Reqs.Certification.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                }
              }
            });
          } else if (restDialog.files.length !== 0){
            for (let i = 0; i < restDialog.files.length; i++) {
              const formData = new FormData();
              if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                formData.append('commentary', restDialog.commentary);
              }
              formData.append('File', restDialog.files[i]);
              this.personalService.putUPDATEFILEPersonalRequirement(Id, formData, durationOptionId,
                baseDate).subscribe((restUpdate: any) => {
                if (i === restDialog.files.length - 1) {
                  if (reqName === 'SocialSecurity'){
                    contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  } else if (reqName === 'Certification'){
                    contractSeletedData.Reqs.Certification.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  }
                }
                this.getContractsOffline(this.indexSelect);
              });
            }
          } else if (restDialog.commentary !== '' && restDialog.commentary !== undefined || durationOptionId || baseDate) {
            this.requestService.putRequirementFileComment(data.RequirementId, this.personalCompanyInfoId, this.employerId,
              restDialog.commentary, durationOptionId, baseDate).subscribe((rest: any) => {
              if (reqName === 'SocialSecurity'){
                contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                  if (data.Id === social.Id) {
                    social.DocsJSON = rest.DocsJSON;
                  }
                });
              } else if (reqName === 'Certification'){
                contractSeletedData.Reqs.Certification.forEach(social => {
                  if (data.Id === social.Id) {
                    social.DocsJSON = rest.DocsJSON;
                  }
                });
              }
              this.getContractsOffline(this.indexSelect);
            });
          }
        } else if (data.Model === undefined) {
          if (Object.keys(restDialog.DocsJSON).length !== 0) {
            const model = {
              DocsJSON: restDialog.DocsJSON,
              Id,
              Module: 'Personal'
            };
            this.personalService.putDELETEEmployerPersonalRequirement(data.RequirementId, model).subscribe((restDelete: any) => {
              if (restDialog.files.length !== 0){
                for (let i = 0; i < restDialog.files.length; i++) {
                  const formData = new FormData();
                  if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                    formData.append('commentary', restDialog.commentary);
                  }
                  formData.append('File', restDialog.files[i]);
                  this.personalService.putUPDATEFILEEmployerPersonalRequirementPlanilla(data.RequirementId, this.personalCompanyInfoId,
                    this.contractSelected.EmployerId , formData).subscribe((restUpdate: any) => {
                    if (i === restDialog.files.length - 1) {
                      if (reqName === 'SocialSecurity'){
                        contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      } else if (reqName === 'Certification'){
                        contractSeletedData.Reqs.Certification.forEach(social => {
                          if (data.Id === social.Id) {
                            social.DocsJSON = restUpdate.DocsJSON;
                          }
                        });
                      }
                    }
                  });
                  this.getContractsOffline(this.indexSelect);
                }
              } else {
                if (reqName === 'SocialSecurity'){
                  contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                } else if (reqName === 'Certification'){
                  contractSeletedData.Reqs.Certification.forEach(social => {
                    if (data.Id === social.Id) {
                      social.DocsJSON = restDelete.DocsJSON;
                    }
                  });
                }
              }
            });
          } else if (restDialog.files.length !== 0){
            for (let i = 0; i < restDialog.files.length; i++) {
              const formData = new FormData();
              if (restDialog.commentary !== '' && restDialog.commentary !== undefined) {
                formData.append('commentary', restDialog.commentary);
              }
              formData.append('File', restDialog.files[i]);
              this.personalService.putUPDATEFILEEmployerPersonalRequirementPlanilla(data.RequirementId, this.personalCompanyInfoId,
                this.contractSelected.EmployerId , formData).subscribe((restUpdate: any) => {
                if (i === restDialog.files.length - 1) {
                  if (reqName === 'SocialSecurity'){
                    contractSeletedData.Reqs.SocialSecurity.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  } else if (reqName === 'Certification'){
                    contractSeletedData.Reqs.Certification.forEach(social => {
                      if (data.Id === social.Id) {
                        social.DocsJSON = restUpdate.DocsJSON;
                      }
                    });
                  }
                }
              });
            }
          }
        }
      }
    });
  }

  goContract(id) {
    if (id !== undefined) {
      this.router.navigate(['/admin/contract/contract', id]);
    }
  }

  getDateFormatR(date): string {
    let response = '';
    if (date !== null) {
      response = this.fechasService.getDateFormatR(date);
    }
    return response;
  }

  showPopupBlackList(message: string,  mode: 'SANCTION' | 'VETO' ) {
    const canSanction = this.exitPermissionCompany('personalblacklistsanction.view');
    const isVetoed = this.flagVeto === true;

    if (mode === 'SANCTION' && canSanction && isVetoed) {
      this.dialogService.openDialogConfirm('El trabajador ya tiene una sancion, y no se puede modificar', false,
        true, '', 'ACEPTAR');
      return;
    }
    this.dialogService.openDialogConfirm(message, true, true, 'CANCELAR', 'CONFIRMAR').afterClosed().subscribe(rest => {
      if (rest !== false){
        this.handleDialogBlackList(mode);
      }
    });
  }

  handleDialogBlackList(mode: 'SANCTION' | 'VETO'){
    const employerIds = this.contracts.map(x => x.EmployerId);
    this.dialogService.openDialogSelectedCausal('CANCELAR', 'CONFIRMAR',
      this.personal.DocumentType, this.personal.DocumentNumber, this.personal.CompanyInfoId,
      employerIds, mode).afterClosed().subscribe(res => {
      if (res !== false){
        this.validateListF(this.personal.DocumentType, this.personal.DocumentNumber, this.personal.CompanyInfoId);
      }
    });
  }

  selectContract(index: number, startOnInit?) {
    if (startOnInit === true) {
      this.changeSelectedContract(index);
    } else if (index !== this.indexSelect) {
      this.changeSelectedContract(index);
    }
  }

  changeSelectedContract(index) {
      this.indexSelect = index;
      this.personalContractProyectSelected = undefined;
      this.contractSelected = undefined;
      if (this.hasActiveContracts === true){
        this.contractSelected = this.prioritizeContracts(this.filterContracts)[this.indexSelect];
      }else{
        this.contractSelected = this.prioritizeContracts(this.contracts)[this.indexSelect];
      }
      this.hasDocuments = this.contractSelected?.HasDocuments;
      this.isActive = this.contractSelected?.IsActive;

      this.formVigencia.get('Position').setValue(this.contractSelected?.Position);
      this.formVigencia.get('IsActive').setValue(this.contractSelected?.IsActive);
      this.formVigencia.get('HasDocuments').setValue(this.contractSelected?.HasDocuments);
      this.formVigencia.get('DescriptionPersonalType').setValue(this.contractSelected?.DescriptionPersonalType);
      this.formVigencia.get('CompanyInfoParentId').setValue(this.contractSelected?.CompanyInfoParentId);
      this.formVigencia.get('SearchEmpleador').setValue('');
      this.configContractOffice(index, this.contractsOffline, this.contractSelected);
      this.getPersonalInfoId();
      this.getSelectedContractsPosition(true);
      this.changePositionsIndividualContract();
      this.getPersonalEmployerInfoExit();

      // ChangeNameEmpleadorName
      this.getNamePersonalEmployerNameSelected(this.contractSelected?.EmployerId);

      // Lis employer documentos
      this.getTrainings(this.contractSelected.EmployerId);
  }

  getRequirementsUptadeInfo(e?) {
    if (1 === 1) {
      const nationality = this.formPersonal.get('Nationality').value;
      const currentDoc = this.formPersonal.get('DocumentType')?.value;
      this.commonServices.getCommonOptionsLocalOrApi('CoPs_CompanyDocumentType').subscribe(options => {
        this.companyDocumentType = this.filterCompanyDocumentTypes(options, nationality, currentDoc);
        if (nationality === '0') {
          if (!this.companyDocumentType.some(x => this.compareDocumentType(x.Value, currentDoc))) {
            this.formPersonal.get('DocumentType').setValue('CC');
          }
        } else {
          if (!this.companyDocumentType.some(x => this.compareDocumentType(x.Value, currentDoc))) {
            const defaultDoc = this.companyDocumentType.find(x => x.Value === 'PE' || x.Value === 'PPT' || x.Value === 'CE')?.Value || 'PE';
            this.formPersonal.get('DocumentType').setValue(defaultDoc);
          }
        }
      });
    }
  }

  selectContractLabor(index: number, startOnInit?) {
    if (startOnInit === true) {
      this.changeSelectedContractLabor(index);
    } else if (index !== this.indexSelectContracLabor) {
      this.changeSelectedContractLabor(index);
    }
  }

  changeSelectedContractLabor(index) {
      this.indexSelectContracLabor = index;
      this.contractLaborSelected = undefined;
      this.contractLaborSelected = this.visibleLaborContractsSorted[this.indexSelectContracLabor];

      this.formDatosContrato.get('ContractNumber').setValue(this.contractLaborSelected?.ContractNumber);
      this.formDatosContrato.get('EmployerInfoId').setValue(this.contractLaborSelected?.EmployerInfoId);
      this.formDatosContrato.get('ContractTypeId').setValue(this.contractLaborSelected?.ContractTypeId);
      this.formDatosContrato.get('PositionName').setValue(this.contractLaborSelected?.PositionName);
      this.formDatosContrato.get('Salary').setValue(this.contractLaborSelected?.Salary);
      this.formDatosContrato.get('AuxiliaryTransport').setValue(this.contractLaborSelected?.TransportationAllowance);
      this.formDatosContrato.get('TotalEarnings').setValue(this.contractLaborSelected?.TotalEarnings);
      this.formDatosContrato.get('StartDate').setValue(this.contractLaborSelected?.StartDate);
      this.formDatosContrato.get('EndDate').setValue(this.contractLaborSelected?.EndDate);
      this.formDatosContrato.get('BankId').setValue(this.contractLaborSelected?.BankId);
      this.formDatosContrato.get('BankAccount').setValue(this.contractLaborSelected?.BankAccount);
      this.formDatosContrato.get('BankAccountTypeId').setValue(this.contractLaborSelected?.BankAccountTypeId);
      // datos prenomina
      this.formDatosContrato.get('ProjectId').setValue(this.contractLaborSelected?.ProjectId);
      this.formDatosContrato.get('WorkShiftId').setValue(this.contractLaborSelected?.WorkShiftId);
      this.formDatosContrato.get('HasExtraTime').setValue(this.contractLaborSelected?.HasExtraTime);
  }

  getNamePersonalEmployerNameSelected(EmployerId): void {
    const data = this.allEmployers.find(x => x.Id === EmployerId);

    if (data !== undefined) {
      this.employerName = data.Name;
    }

    this.employerId = EmployerId;
  }

  validateIfEmployerContratista(EmployerId, EmployerName): string{
    let is = '';
    const data = this.allEmployers.find(x => x.Id === EmployerId);
    if (data !== undefined) {
      if (EmployerName === data.Name) {
        is = 'Contratista';
      } else {
        is = 'Subcontratista';
      }
    }
    return is;
  }

  getPersonalInfoId() {
    let contractId = '';
    if (this.hasActiveContracts === true){
      contractId = this.filterContracts[this.indexSelect].ContractId;
    }else{
      contractId = this.contracts[this.indexSelect].ContractId;
    }
    this.personalService.getContractPersonalInfoId(contractId, this.personalId).subscribe(
      (restContractPErsonaInfo: PersonalInfoContract) => {
      this.personalInfo = undefined;
      this.personalInfo = restContractPErsonaInfo;
      this.formVigencia.get('StartDateContract').setValue(this.fechasService.getDateHours(restContractPErsonaInfo.StartDate));
      this.formVigencia.get('FinishDateContract').setValue(this.fechasService.getDateHours(restContractPErsonaInfo.FinishDate));
      this.maxDate = this.contractSelected.FinishDateContract;
      this.formVigencia.get('Position').setValue(restContractPErsonaInfo.Position);
      this.formVigencia.get('IsActive').setValue(restContractPErsonaInfo.IsActive);
      this.formVigencia.get('EmployerName').setValue(restContractPErsonaInfo.EmployerName);
      this.formVigencia.get('EmployerItemId').setValue(restContractPErsonaInfo.EmployerId === null ?
        restContractPErsonaInfo.SubContractorId : restContractPErsonaInfo.EmployerId);
      this.formVigencia.get('EmployerId').setValue(restContractPErsonaInfo.EmployerId);
      // Se guarda el primer employer para despues cambiar los requisitos en otro Employer
      this.SubContractorId = restContractPErsonaInfo.SubContractorId;
      this.employerChangeDocument = { EmployerName: restContractPErsonaInfo.EmployerName,
        EmployerId: restContractPErsonaInfo.EmployerId === null ?
          restContractPErsonaInfo.SubContractorId : restContractPErsonaInfo.EmployerId};
      this.formVigencia.get('EmployerLogo').setValue(restContractPErsonaInfo.EmployerLogo);
      this.formVigencia.get('EmployerDocumentType').setValue(restContractPErsonaInfo.EmployerDocumentType);
      this.formVigencia.get('EmployerDocumentNumber').setValue(restContractPErsonaInfo.EmployerDocumentNumber);
      this.formVigenciaArlExigida.get('TypeARL').setValue(restContractPErsonaInfo.TypeARL);
    });
  }

  changeBirthDateCalculate() {
    const edad = this.fechasService.calcularEdad(this.formPersonal.get('BirthDate').value);
    this.edadRange = edad >= this.min
      && edad < this.max;
  }

  generateCarnet(): void {
    this.dialogService.openDialogConfirm('¿Deseas Generar e imprimir un nuevo carnet? Al imprimir un nuevo carnet, se anulará el anterior'
    ).afterClosed().subscribe(dialogResult => {
        if (dialogResult !== false) {
          this.dialogService.openDialogPrintPreCarnet('GENERAR', this.personalInfo).afterClosed().subscribe(printResult => {
              if (printResult === 'GENERADO') {
                window.location.reload();
              }
            });
        }
      });
  }

  printCarnet() {
    this.dialogService.openDialogConfirm('¿Deseas imprimir el carnet?').afterClosed()
      .subscribe(rest => {
        if ( rest !== false) { this.dialogService.openDialogPrintPreCarnet('IMPRIMIR', this.personalInfo); }
      });
  }

  getAllowNonCompliantWorkerActivation() {
    const adminId = this.personal?.CompanyInfoId;
    if (!adminId) { return; }
    this.companiesService.getAdminConfiguration(adminId).subscribe((rest: any) => {
      this.companiesService.allowNonCompliantWorkerActivation = rest?.AllowNonCompliantWorkerActivation ?? false;
    });
  }

  associateContrac(dataModuleRequest?) {
    this.dialogService.openDialogPersonAssociateContracts(this.personalCompanyInfoId, this.personalContractProyect,
      this.infoPersonalCompanyPersonalId.Projects, dataModuleRequest, false, this.personal.CompanyInfoId).afterClosed().subscribe(rest => {
      if (rest === true) {
        this.getContractPersonal();
        this.requestService.setEmployerIdPersonalId(undefined);
      } else {
        this.requestService.setEmployerIdPersonalId(undefined);
      }
    });
  }

  private hasPermAdd(): boolean {
    return this.exitPermissionCompany('contractspersonals.add');
  }

  private hasPermButton(): boolean {
    return this.exitPermissionCompany('contractspersonals.button');
  }

  private isInBlacklist(): boolean {
    return (this.flagListF === true || this.flagVeto === true) || this.flagBlackListFuture === true ||
      (this.flagListFInfo?.BlackList === true || this.flagVetoInfo?.BlackList === true);
  }

  isActivarDisabled(): boolean {
    if (this.isInBlacklist()) { return true; }

    const hasAdd = this.hasPermAdd();
    const hasBtn = this.hasPermButton();

    if (!hasAdd) { return true; }
    if (hasAdd && !hasBtn) { return false; }

    return this.disableButtonContract();
  }

  activarTooltip(): string {
    const hasAdd = this.hasPermAdd();
    const hasBtn = this.hasPermButton();

    if (!hasAdd) {
      return 'Apagado porque no cuenta con el permiso';
    }

    if (hasAdd && !hasBtn) { return ''; }
    if (this.disableButtonContract()) {
      return !this.hasDocuments
        ? 'Apagado por incumplimiento de requisitos'
        : 'Apagado porque no cuenta con el permiso';
    }
    return '';
  }

  activarBtnClass(): string {
    if (this.isInBlacklist()) { return 'disabledAnalityco'; }

    const hasAdd = this.hasPermAdd();
    const hasBtn = this.hasPermButton();

    if (!hasAdd) { return 'disabledAnalityco'; }
    if (hasAdd && !hasBtn) { return 'blueAnalityco'; }

    return this.isActivarDisabled() ? this.disableButtonContractString() : 'blueAnalityco';
  }

  inactiveContrac() {
    this.dialogService.openDialogSelectDateDisabledComponent('Inhabilitar el acceso en todos los contratos'
    ).afterClosed().subscribe(rest => {
      if (rest !== false) {
        const endDate = rest.date;
        // Solo inactivar los contratos que el usuario puede ver (filterContracts ya está filtrado por permisos del servidor)
        const visibleActive = this.filterContracts.filter(c => c?.IsActive === true);
        if (visibleActive.length === 0) { return; }

        forkJoin(visibleActive.map(contract =>
          this.personalService.getContractPersonalInfoId(contract.ContractId, this.personalId)
        )).subscribe((personalInfoContracts: any[]) => {
          forkJoin(personalInfoContracts.map((personalInfoContract: any, idx: number) => {
            const contract = visibleActive[idx];
            return this.personalService.postContractPersonalInfoId(
              contract.ContractId,
              contract.PersonalContractId,
              { ...personalInfoContract, FinishDate: endDate, tillEndOfDay: false, Module: 'Personal' }
            );
          })).subscribe(() => {
            const firedIds = new Set(visibleActive.map(va => String(va.ContractId)));
            this.personalService.getContractPersonalInfoId(
              this.filterContracts[this.indexSelect]?.ContractId,
              this.personalId
            ).subscribe((restContractPErsonaInfo: PersonalInfoContract) => {
              this.contracts.forEach(contract => {
                if (contract.IsActive === true && firedIds.has(String(contract.ContractId))) {
                  contract.FinishDate = restContractPErsonaInfo.FinishDate;
                }
              });
              this.formVigencia.get('FinishDateContract')
                .setValue(this.fechasService.getDateHours(restContractPErsonaInfo.FinishDate));
              this.flagChangeDataBtnSave = false;
              // Ajuste local: marcar inactivos solo los contratos visibles que se inactivaron
              this.contracts = (this.contracts ?? []).map(c =>
                firedIds.has(String(c?.ContractId)) ? { ...c, IsActive: false } : c
              );
              this.refreshContractsView();
              this.updateBannerFromData();
              this.showOnlyInactiveBanner = true;
              this.showOnlyActive = true;
              localStorage.setItem('cardsPersonal_showOnlyActive', '1');
              localStorage.setItem('cardsPersonal_showInactiveBanner', '1');
              this.reloadPage(true);
            });
          });
        });
      }
    });
  }

  openAcceso() {
    this.dialogService.openDialogAdminAccesoPersonal(this.contractSelected, 'Personal' ).afterClosed().subscribe(rest => {
      if (rest === true) {
        this.getContractsOffline(this.indexSelect);
      }
    });
  }

  openDialogPhotoPersonal(): void {
    this.dialogService.openDialogGestorImgPersonal('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true,
      undefined, this.permissionsCompany, this.personal?.CompanyInfoId).afterClosed().subscribe((res: any) => {
        if (!res) { return; }

        const MAX = 10_000_000;
        const isFormData = (x: any): x is FormData => x && typeof x.append === 'function' && typeof x.get === 'function';
        const original = res?.meta?.originalBytes as number | undefined;
        if (typeof original === 'number' && original > MAX) {
          this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
          return;
        }

        const fd: FormData = isFormData(res) ? res : isFormData(res?.FormData) ? res.FormData : null;

        if (!fd) { return; }

        const fileOrBlob = fd.get('File') as File | Blob | null;
        if (!fileOrBlob) {return; }

        if (fileOrBlob.size > MAX) {
          this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
          return;
        }

        this.personalService.updatePhotoCompanyInfo(this.personalCompanyInfoId, fd).subscribe(
          () => {
            this.getInfoPersonalCompanyPersonalIdUpdatePhoto();
            this.checkPhotoQualityAndSyncRequestChange(this.personalCompanyInfoId);
            setTimeout(() => {
              this.checkPhotoQualityAndSyncRequestChange(this.personalCompanyInfoId);
            }, 2500);
            this.snackBService.openSuccess('Foto Actualizada', '', 4000);
          },
          (err) => {
            if (err?.status === 422 && err?.error) {
              const errBody = err.error;
              if (errBody.reasons && Array.isArray(errBody.reasons) && errBody.reasons.length > 0) {
                this.snackBService.openWarning(errBody.reasons.join('. '), '', 6000);
              } else if (errBody.error === 'INVALID_REFERENCE_PHOTO') {
                this.snackBService.openWarning('La foto no cumple con las reglas de validación', '', 5000);
              } else {
                this.snackBService.openWarning(errBody.Error || errBody.message || 'Error al validar la foto', '', 5000);
              }
            } else if (err?.error?.Error) {
              this.snackBService.openWarning(err.error.Error, '', 5000);
            } else {
              this.snackBService.openWarning('Error al actualizar la foto', '', 4000);
            }
          }
        );
      });
  }

  openDialogDetailsSurveySymptoms(SurveyId) {
    if (SurveyId !== undefined && SurveyId !== null) {
      this.dialogService.openDialogDetailsSurveySymptoms(SurveyId).afterClosed().subscribe(restDialog => {

      });
    } else {
      this.snackBService.openWarning('No tiene reporte de sintomas diario', '', 3000);
    }
  }

  getContractNumber(contracts: string): string {
    let contractsList: string;

    if (contracts.split(']')[1] !== undefined) {
      try {
        contractsList = JSON.parse(contracts);
      } catch {
        contractsList = contracts;
      }
    } else {
      contractsList = contracts;
    }
    return contractsList;
  }

  getInfoPersonalCompanyPersonalIdUpdatePhoto() {
    this.personalService.getInfoPersonalCompanyPersonalId(this.personalCompanyInfoId, true).subscribe(
      (infoPersonalCompanyPersonalId: InfoPersonalCompanyPersonalId) => {
        this.personal.Photo = infoPersonalCompanyPersonalId.Photo;
        this.personal.RequestPhotoChange = infoPersonalCompanyPersonalId.RequestPhotoChange;
        this.requestPhotoChange = !!infoPersonalCompanyPersonalId.RequestPhotoChange;
        this.formPersonal.get('Photo').setValue(this.personal.Photo);
        this.checkPhotoQualityAndSyncRequestChange(this.personalCompanyInfoId);
      });
  }

  checkPhotoQualityAndSyncRequestChange(personalCompanyInfoId: string | number): void {
    if (!personalCompanyInfoId) { return; }
    this.personalService.getFaceValidation(personalCompanyInfoId).subscribe(
      (res: FaceValidation) => {
        if (!res) { return; }
        const validation = res?.Validation;
        if (!validation || validation.PhotoValidationMode === 'Off') {
          return;
        }

        const hasRulesFailure = validation.Rules?.some((r: any) => r.Passed === false);
        const hasBlockFailure = validation.IsSuccess === false;

        const isFailed = !!(hasRulesFailure || hasBlockFailure);

        if (isFailed) {
          this.isPhotoQualityFailed = true;
          if (this.personal) {
            this.personal.RequestPhotoChange = true;
          }
          if (this.infoPersonalCompanyPersonalId) {
            this.infoPersonalCompanyPersonalId.RequestPhotoChange = true;
          }
          this.requestPhotoChange = true;
          this.personalService.putSaveRequestPhotoChange(personalCompanyInfoId, { RequestPhotoChange: true }).subscribe(
            () => {},
            (err) => console.error('Error guardando RequestPhotoChange', err)
          );
        } else {
          this.isPhotoQualityFailed = false;
        }
      },
      () => {}
    );
  }

  changeTypeRiesgo(TypeARL) {
    this.personalInfo.TypeARL = TypeARL;
    if (this.docsUploadIniadoSocialSecurity.length > 0) {
      const exitDocArl = this.docsUploadIniadoSocialSecurity.find(x => (x.TypeARL !== undefined && x.TypeARL !== null && x.TypeARL !== ''));
      if (exitDocArl !== undefined) {
        const value = this.commonMetodService._compareNumberRomans(exitDocArl.TypeARL, TypeARL);
        if (value === '=' || value === '>') {
          this.IsValidedARL = true;
        } else if (value === '<') {
          this.IsValidedARL = false;
        }
      }
    }
  }

  changeDateRequirement(Model, IdDocument, Fecha, TypeARL?) {
    this.flagChangeDataBtnSave = true;
    if (TypeARL !== undefined){
      if (this.personalInfo.TypeARL !== null) {
        const value = this.commonMetodService._compareNumberRomans(TypeARL, this.personalInfo.TypeARL);
        if (value === '=' || value === '>') {
          this.IsValidedARL = true;
        } else if (value === '<') {
          this.IsValidedARL = false;
        }
      }
    }
    let date = null;
    if (Fecha !== undefined && Fecha !== null) {
      date = this.fechasService.getDateFormatDatePiker23(this.fechasService.formatDateYYYYMMDDdatePiker23(Fecha));
    }
    const obj = {
      Date: date,
      Id: IdDocument,
      Model,
      TypeARL
    };
    // Documentos carga iniciado APi
    if (this.docsUploadIniadoSocialSecurity.length === 0) {
      this.docsUploadIniadoSocialSecurity.push(obj);
    } else {
      if (this.exitDocumentDocsUploadIniadoSocialSecurity(IdDocument) === true){
        for (const doc of this.docsUploadIniadoSocialSecurity) {
          if (IdDocument === doc.Id) {
            if (date !== null && date !== undefined) {
              doc.Date = date;
            } else if (TypeARL !== null && TypeARL !== undefined) {
              doc.TypeARL = TypeARL;
            }
          }
        }
      } else {
        this.docsUploadIniadoSocialSecurity.push(obj);
      }
    }
    if (this.dateSocialSecurityUpload.length === 0) {
      if (obj.Date === null || obj.Date === undefined) {
        const uploaddocument = this.docsUploadIniadoSocialSecurity.find(x => IdDocument === x.Id);
        uploaddocument !== undefined ? obj.Date = uploaddocument.Date : obj.Date = obj.Date;
        this.dateSocialSecurityUpload.push(obj);
      } else if (obj.TypeARL === undefined || obj.TypeARL === null) {
        const uploaddocument = this.docsUploadIniadoSocialSecurity.find(x => IdDocument === x.Id);
        uploaddocument !== undefined ? obj.TypeARL = uploaddocument.TypeARL : obj.TypeARL = obj.TypeARL;
        this.dateSocialSecurityUpload.push(obj);
      } else {
        this.dateSocialSecurityUpload.push(obj);
      }
    } else {
      if (this.exitDocumentDateSocialSecurityUpload(IdDocument) === true){
        for (const doc of this.dateSocialSecurityUpload) {
          if (IdDocument === doc.Id) {
            if (date !== null && date !== undefined) {
              doc.Date = date;
            } else if (TypeARL !== null && TypeARL !== undefined) {
              doc.TypeARL = TypeARL;
            }
          }
        }
      } else {
        if (obj.Date === null || obj.Date === undefined) {
          const uploaddocument = this.docsUploadIniadoSocialSecurity.find(x => IdDocument === x.Id);
          uploaddocument !== undefined ? obj.Date = uploaddocument.Date : obj.Date = obj.Date;
          this.dateSocialSecurityUpload.push(obj);
        } else if (obj.TypeARL === undefined || obj.TypeARL === null) {
          const uploaddocument = this.docsUploadIniadoSocialSecurity.find(x => IdDocument === x.Id);
          uploaddocument !== undefined ? obj.TypeARL = uploaddocument.TypeARL : obj.TypeARL = obj.TypeARL;
          this.dateSocialSecurityUpload.push(obj);
        } else {
          this.dateSocialSecurityUpload.push(obj);
        }
      }
    }
  }

  changeExpeditionDate(Fecha) {
    let date;
    if (Fecha !== undefined && Fecha !== null) {
      date = this.fechasService.getDateFormatDatePiker(this.fechasService.formatDateYYYYMMDDdatePiker(Fecha));
      this.controlExpeditionDate.setValue(date);
      this.flagChangeDataBtnSave = true;
    }
  }

  changeControlExpeditionPlace() {
    this.flagChangeDataBtnSave = true;
  }

  exitDocument(Id: any): boolean {
    let exit = false;
    const data = this.docsUploadIniadoSocialSecurity.find(x => x.Id === Id);
    if (data !== undefined) {
      exit = true;
    }
    return exit;
  }

  getCalculateStateDate(date, id?): string {
    let response: string;
    response = this.fechasService.calculateStateDateEndOfDay(date, id);
    return response;
  }

  getCalculateStateDateWithHORA(date, id?): string {
    let response: string;
    response = this.fechasService.calculateStateDateWithHORA(date, id);
    return response;
  }

  getCalculateStateDateAndHourDescription(date, id?): string{
    let response = '';
    if (this.fechasService.calculateStateDateWithHORA(date, id) === 'DateRed'){
      response = 'INACTIVO';
    }else if (this.fechasService.calculateStateDateWithHORA(date, id) === 'DateOrange'){
      response = 'POR VENCER';
    }
    return response;
  }

  getIsOutDate(date, id?): boolean{
    let response = false;
    if (this.fechasService.calculateStateDateWithHORA(date, id) === 'DateRed'){
      response = true;
    }else if (this.fechasService.calculateStateDateWithHORA(date, id) === 'DateOrange'){
      response = true;
    }
    return response;
  }

  getCalculateStateDateMore(date, id?): string {
    let response: string;
    response = this.fechasService.calculateStateDateMore(date, id);
    return response;
  }

  getCalculateStateDateMoreLabel(date, id?): string {
    let response = '';
    let stateStyle: string;
    stateStyle = this.fechasService.calculateStateDateMore(date, id);

    if (stateStyle === 'DateRed'){
      response = 'INACTIVO';
    }
    return response;
  }

  getCalculateStateDateString(date, id?): string {
    let response: string;
    response = this.fechasService.calculateStateDate(date, id) + '-string';
    return response;
  }

  getDateDocsUploadIniadoSocialSecurity(Id): string {
    let date: string;
    const newDate = this.docsUploadIniadoSocialSecurity.find(x => x.Id === Id);
    newDate !== undefined && newDate !== null ? date = newDate.Date : date = '';
    return date;
  }

  replaceEPSorAFP(data: ReplaceEPSorAFP): void {
    if (this.replaceEPSorAFPdata.length === 0) {
      this.replaceEPSorAFPdata.push(data);
    } else {
      let found = false;

      for (const item of this.replaceEPSorAFPdata) {
        if (item.path === data.path) {
          item.value = data.value;
          found = true;
          break;
        }
      }

      if (!found) {
        this.replaceEPSorAFPdata.push(data);
      }
    }

    if (data.path === '/EpsId') {
      this.formPersonal.get('EpsId')?.setValue(data.value);
      this.flagChangeContratista = true;
    } else if (data.path === '/AfpId') {
      this.formPersonal.get('AfpId')?.setValue(data.value);
      this.flagChangeContratista = true;
    }
  }

  changeCCF(ccf){
    this.flagChangeCCFPersonal = true;
    this.formPersonal.get('CCFId').setValue(ccf);
  }

  changeEPSAFP(e, type) {
    if (type === 'AFP') {
      if (this.replaceEPSorAFPdata.length === 0) {
        this.replaceEPSorAFPdata.push({path: '/AfpId', value: e});
        this.controAfp.setValue(e);
        this.flagChangeContratista = true;
      } else {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.replaceEPSorAFPdata.length; i++) {
          if (this.replaceEPSorAFPdata[i].path === '/AfpId'){
            this.replaceEPSorAFPdata[i].value = e;
            this.controAfp.setValue(e);
            this.flagChangeContratista = true;
          } else {
            this.replaceEPSorAFPdata.push({path: '/AfpId', value: e});
            this.controAfp.setValue(e);
            this.flagChangeContratista = true;
          }
        }
      }

    } else if (type === 'EPS') {
      if (this.replaceEPSorAFPdata.length === 0) {
        this.replaceEPSorAFPdata.push({path: '/EpsId', value: e});
        this.controEps.setValue(e);
        this.flagChangeContratista = true;
      } else {
        for (const item of this.replaceEPSorAFPdata) {
          if (item.path === '/EpsId') {
            item.value = e;
            this.controEps.setValue(e);
            this.flagChangeContratista = true;
          } else {
            this.replaceEPSorAFPdata.push({ path: '/EpsId', value: e });
            this.controEps.setValue(e);
            this.flagChangeContratista = true;
          }
        }
      }
    }
    this.changeAfterfillFormPersonal = true;
  }

  getDateRequirement(Id): string {
    for (const doc of this.docsUploadIniadoSocialSecurity) {
      if (Id === doc.Id) {
        return doc.Date;
      }
    }
  }

  convertirAMayusculas(event: any, formGroup: FormGroup, controlName: string) {
    const input: HTMLInputElement = event.target;
    const cursorPosition = input.selectionStart;
    const upperValue = (input.value || '').toUpperCase();

    input.value = upperValue;
    formGroup.get(controlName)?.setValue(upperValue, { emitEvent: false });
    input.setSelectionRange(cursorPosition, cursorPosition);
  }

  convertirAMinusculas(event: any, formGroup: FormGroup, controlName: string) {
    const input: HTMLInputElement = event.target;
    const cursorPosition = input.selectionStart;
    const lowerValue = (input.value || '').toLowerCase();

    input.value = lowerValue;
    formGroup.get(controlName)?.setValue(lowerValue, { emitEvent: false });
    input.setSelectionRange(cursorPosition, cursorPosition);
  }

  exitPermissionCompany(permiso: string): boolean {
    let exit: boolean;
    const permisionsUserInfo  = this.permissionsCompany.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }

 isPhotoChangeRequired(): boolean {
  return this.personal?.RequestPhotoChange === true
    || this.isPhotoQualityFailed === true;
}

canChangePhoto(): boolean {
  return this.exitPermissionCompany('personals.update')
    || (
      this.isPhotoChangeRequired()
      && this.exitPermissionCompany('personals.update.photorequiredchange')
    );
}

  validatePersonalAlert(): boolean{
    let isValided = false;

    if (this.hasDocuments === true && this.isActive === true){
      isValided = true;
    }

    return isValided;
  }

  subTitlePersonalAlert(): string{
    if (this.hasDocuments === true && this.isActive === true){
      return 'En el contrato ' + this.filterContracts[this.indexSelect]?.ContractNumber + ' cumple los requisitos';
    }else if (this.hasDocuments === false && this.isActive === true){
      return 'En el contrato ' + this.filterContracts[this.indexSelect]?.ContractNumber + ' no cumple los requisitos';
    }else if (this.hasDocuments === true && this.isActive === false){
      return 'Fin del acceso vencido. (Inactivo)';
    }else if (this.hasDocuments === false && this.isActive === false){
      return 'Fin del acceso vencido. (Inactivo) y no cumple los requisitos';
    }
    return '';
  }

  disableButtonContractString(): string{
    if (!this.exitPermissionCompany('contractspersonals.add')) {
      return 'disabledAnalityco';
    }
    if ((this.flagListF === true || this.flagVeto === true)) {
      return 'disabledAnalityco';
    }
    if (this.hasDocuments || this.companiesService.allowNonCompliantWorkerActivation === true) {
      return 'blueAnalityco';
    }
    return 'disabledAnalityco';
  }

  disableButtonContract(): boolean{
    if (!this.exitPermissionCompany('contractspersonals.add')) {
      return true;
    }
    if ((this.flagListF === true || this.flagVeto === true)) {
      return true;
    }
    if (this.hasDocuments || this.companiesService.allowNonCompliantWorkerActivation === true) {
      return false;
    }
    return true;
  }

  getTrainings(employerId){
    this.personalService.getTrainingWithExam(this.personalId, employerId).subscribe((rest: any) => {
      this.trainings = rest;
      this.sortedTrainings = this.sortTrainings(rest);
    });
  }

  sortTrainings(trainings: any[]): any[] {
    const vencidasRenovar = [];
    const proximasAVencer = [];
    const vencimientoLejano = [];
    const vencidasNoRenovar = [];
    const now = new Date().getTime();
    const soonLimit = new Date();
    soonLimit.setMonth(soonLimit.getMonth() + 1);

    for (const item of trainings) {
      const requiereRenovacion = item.RequiresRenewal;
      const passed = item.Passed === true;

      if (!passed) {
        vencidasNoRenovar.push({ item, venceTexto: '', venceColor: '' });
        continue;
      }

      const vencimiento = new Date(item.ExpirationDate).getTime();
      const fechaFormateada = this.formatDate(item.ExpirationDate);

      if (vencimiento < now && requiereRenovacion) {
        vencidasRenovar.push({
          item,
          venceTexto: `Vence: ${fechaFormateada} - Requiere revisión`,
          venceColor: 'red'
        });
      } else if (vencimiento < soonLimit.getTime() && requiereRenovacion) {
        proximasAVencer.push({
          item,
          venceTexto: `Vence: ${fechaFormateada} - Requiere revisión`,
          venceColor: 'orange'
        });
      } else if (requiereRenovacion) {
        vencimientoLejano.push({
          item,
          venceTexto: `Vence: ${fechaFormateada}`,
          venceColor: 'grey'
        });
      } else {
        vencidasNoRenovar.push({
          item,
          venceTexto: `Vence: ${fechaFormateada} - No requiere renovación`,
          venceColor: 'grey'
        });
      }
    }

    return [...vencidasRenovar, ...proximasAVencer, ...vencimientoLejano, ...vencidasNoRenovar];
  }

  formatDate(date: string): string {
    const d = new Date(date);
    return `${d.getDate()} ${d.toLocaleString('default', { month: 'short' })} ${d.getFullYear()}`;
  }

  getEmployerName(item: any): string {
    return item?.EmployerName
      ?? item?.EmployerInfo?.Name
      ?? '';
  }

  historyTraining(evaluationId: number, employerName: string, approvalPercentage: number): void {
    if (!evaluationId) { return; }

    Promise.resolve().then(() => {
      this.dialogService.openDialogTrainingsEvaluationsHistorical(
        evaluationId, String(employerName ?? ''), approvalPercentage);
    });
  }

  getExpansionConfigValue(name): boolean {
    let value = true;
    if (this.expansionConfig.find(x => x.name === name)?.value !== undefined) {
      value = this.expansionConfig.find(x => x.name === name).value;
    }
    return value;
  }

  exitExpansionConfig() {
    const data = localStorage.getItem('expansionConfig');
    if (data === undefined || data ===  null) {
      localStorage.setItem('expansionConfig', JSON.stringify(this.expansionConfig));
    } else {
      this.expansionConfig = JSON.parse(localStorage.getItem('expansionConfig'));
    }
  }
  // metodos expansionConfig Final

  private buildAllUnique(): void {
    const map = new Map<string | number, ContractsOffline>();
    const keyOf = (c: any) => c?.Id ?? `${c?.ContractNumber}-${c?.EmployerId}`;
    for (const c of [...this.filterContracts, ...this.filterContracts]) {
      const k = keyOf(c);
      if (!map.has(k)) { map.set(k, c); }
    }
    this.contractsAll = Array.from(map.values());
  }

  private rebuildAllUnique(): void {
    const map = new Map<string | number, ContractsOffline>();
    const keyOf = (c: any) => c?.Id ?? `${c?.ContractNumber}-${c?.EmployerId}`;
    for (const c of [...(this.filterContracts || []), ...(this.filterContracts || [])]) {
      const k = keyOf(c);
      if (!map.has(k)) { map.set(k, c); }
    }
    this.contractsAll = Array.from(map.values());
  }

  getVisibleContracts(): any[] {
    const activos   = this.filterContracts;

    if (this.showOnlyActive) {
      return this.prioritizeContracts(activos.filter(c => !!c?.IsActive));
    }
    return this.prioritizeContracts(this.filterContracts);
  }

  private updateBannerFromData(): void {
    if (!this.showOnlyActive) { return; }
    const base =
      (Array.isArray(this.contracts) && this.contracts.length) ? this.contracts :
          (Array.isArray(this.contractsOffline) ? this.contractsOffline : []);
    this.showOnlyInactiveBanner = !base.some(c => !!c?.IsActive);
  }

  openMassiveArlDialog(): void {
    const openDialog = (contractsOffline: any[]) => {
        const acc: any[] = [];
        contractsOffline.forEach((pc: any) => {
            if (pc.ProjectContracts) {
                JSON.parse(pc.ProjectContracts).forEach((p: any) => {
                    acc.push({ PersonalProyect: p, PersonalContract: pc });
                });
            }
        });

        this.dialogService.openDialogPersonAssociateContracts(this.personalCompanyInfoId, acc,
            this.infoPersonalCompanyPersonalId.Projects, undefined, false, this.personal.CompanyInfoId, true).afterClosed().subscribe(rest => {
            if (rest === true) {
                this.getContractPersonal();
                this.getContractsOffline(this.indexSelect);
                this.getHistory();
            } else if (rest && rest.employerInfoId && rest.typeArl) {
                console.log('--- DEBUG MASSIVE ARL ---');
                console.log('Enviando petición a putMassiveTypeARL con los siguientes datos:');
                console.log('employerInfoId:', rest.employerInfoId);
                console.log('personalCompanyInfoId:', Number(this.personalCompanyInfoId));
                console.log('typeArl:', rest.typeArl);
                
                this.contractService.putMassiveTypeARL(rest.employerInfoId, Number(this.personalCompanyInfoId), rest.typeArl, '0').subscribe((res: any) => {
                    console.log('Respuesta recibida de la API:', res);
                    
                    if (res?.Updated > 0) {
                        this.snackBService.openSuccess(`Tipo de riesgo ARL ${res.TypeARL} asignado a ${res.Updated} contratos.`);
                    } else if (res?.Updated === 0) {
                        this.snackBService.openWarning('No había contratos activos por actualizar con ese tipo de riesgo.', undefined, 3000);
                    }
                    this.getContractsOffline(this.indexSelect);
                    this.getHistory();
                    
                    // Aumentado a 10 minutos para depuración
                    setTimeout(() => {
                        this.reloadPage(true);
                    }, 600000);
                }, (error) => {
                    console.error('Error recibido de la API:', error);
                    if (error?.error?.Error) {
                        this.snackBService.openError(error.error.Error);
                    } else {
                        this.snackBService.openError('No se pudo cambiar el tipo de riesgo ARL');
                    }
                });
            }
        });
    };

    if (this.inactiveContractsLoaded && this.allContractsActiveInactive) {
        openDialog(this.allContractsActiveInactive);
    } else {
        this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, false)
            .subscribe((res: any[]) => {
                openDialog(res || []);
            });
    }
  }

  onShowAllFromInactiveBanner(): void {
    if (!this.inactiveContractsLoaded) {
      this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, false)
        .pipe(take(1)).subscribe(res => {
          this.inactiveContractsLoaded = true;
          this.allContractsActiveInactive = res;
          this.contractsOffline = res;
          this.filterContracts = this.prioritizeContracts((res || []).map(c => this.decorateContractForUI(c)));
          if (!this.hasInactiveContracts()) {
            this.snackBService.openWarning('QUE NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
            this.showOnlyInactiveBanner = false;
            return;
          }
          this.showOnlyActive = false;
          this.showOnlyInactiveBanner = false;
        });
      return;
    }
    if (!this.hasInactiveContracts()) {
      this.snackBService.openWarning('QUE NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
      this.showOnlyInactiveBanner = false;
      return;
    }
    this.showOnlyActive = false;
    this.showOnlyInactiveBanner = false;
  }

  private hasInactiveContracts(): boolean {
    return (this.filterContracts || []).some(c => !c?.IsActive);
  }

  onToggleClick(): void {
    if (this.showOnlyActive) {
      if (!this.inactiveContractsLoaded) {
        this.personalService.getContractsOfflinePersonalCompanyInfoId(this.personalCompanyInfoId, false)
          .pipe(take(1)).subscribe(res => {
            this.inactiveContractsLoaded = true;
            this.allContractsActiveInactive = res;
            this.contractsOffline = res;
            this.filterContracts = this.prioritizeContracts((res || []).map(c => this.decorateContractForUI(c)));
            if (!this.hasInactiveContracts()) {
              this.snackBService.openWarning('NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
              return;
            }
            this.showOnlyActive = false;
            this.showOnlyInactiveBanner = false;
            this.refreshContractsView();
          });
        return;
      }
      if (!this.hasInactiveContracts()) {
        this.snackBService.openWarning('NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
        return;
      }
    }

    this.showOnlyActive = !this.showOnlyActive;
    if (!this.showOnlyActive) {
      this.showOnlyInactiveBanner = false;
      this.refreshContractsView();
    }
  }

  private afterInitialContractsLoad(): void {
    this.filterContracts = (this.contracts || []).map(c => this.decorateContractForUI(c));
    this.prewarmContractsToggle();
  }

  private prewarmContractsToggle(): void {
    // inactive contracts are loaded lazily when the user clicks "Ver Inactivos"
  }

  private reloadPage(hard: boolean = true): void {
    if (hard) {
      window.location.reload();
    } else {
      const url = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigateByUrl(url));
    }
  }

  private decorateContractForUI(c: any): any {
    const clone = { ...c };
    if (!(clone.Control instanceof FormControl)) {
      clone.Control = new FormControl(clone?.EmployerId ?? null);
    }
    return clone;
  }

  getVisibleLaborContracts(): any[] {
    const list: any[] = this.contractsLabor || [];
    if (!list.length) { return list; }
    return this.showOnlyActiveLabor ? list.filter(c => !this.isLaborInactive(c)) : list;
  }

  private sortByEndDateDesc(list: any[]): any[] {
    const isValidDate = (d: any): boolean => {
      if (!d) { return false; }
      const t = +new Date(d);
      return !isNaN(t);
    };
    const ts = (d: any): number => +new Date(d);

    return (list || []).slice().sort((a, b) => {
      const aHasEnd = isValidDate(a?.EndDate);
      const bHasEnd = isValidDate(b?.EndDate);
      if (!aHasEnd && bHasEnd) { return -1; }
      if (!bHasEnd && aHasEnd) { return 1; }
      if (aHasEnd && bHasEnd) {
        const cmpEnd = ts(b.EndDate) - ts(a.EndDate);
        if (cmpEnd !== 0) { return cmpEnd; }
      }

      const aStart = isValidDate(a?.StartDate) ? ts(a.StartDate) : Number.NEGATIVE_INFINITY;
      const bStart = isValidDate(b?.StartDate) ? ts(b.StartDate) : Number.NEGATIVE_INFINITY;
      return bStart - aStart;
    });
  }

  private rebuildVisibleLaborContractsSorted(): void {
    const visible: any[] = this.getVisibleLaborContracts();
    this.visibleLaborContractsSorted = this.sortByEndDateDesc(visible);
    this.updateBannerFlags?.();
    this.loadAllContractWorkShifts();
  }

  private loadAllContractWorkShifts(): void {
    if (!this.visibleLaborContractsSorted?.length) { return; }
    const projectMap = new Map<any, any[]>();
    this.visibleLaborContractsSorted.forEach(item => {
      if (item.ProjectId && (!item.workShiftList || !item.workShiftList.length)) {
        const existing = projectMap.get(item.ProjectId) || [];
        existing.push(item);
        projectMap.set(item.ProjectId, existing);
      }
    });
    projectMap.forEach((items, projectId) => {
      this.personalService.getPersonalWorkShiftrprojectId(projectId).subscribe((rest: any) => {
        const list = (rest || []).filter((w: any) => w.IsActive !== false);
        items.forEach(item => { item.workShiftList = list; });
      });
    });
  }

  toggleShowOnlyActiveLabor(): void {
    if (this.showOnlyActiveLabor && !this.hasInactiveLaborContracts()) {
      this.snackBService.openWarning('NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
      return;
    }
    this.showOnlyActiveLabor = !this.showOnlyActiveLabor;
    this.setLoadingLabor(true);
    if (this.showOnlyActiveLabor) {
      this.getPersonalEmployerInfoExit();
    } else {
      this.fetchAllLaborContracts();
    }
  }

  private fetchAllLaborContracts(): void {
    this.setLoadingLabor(true);
    this.rebuildVisibleLaborContractsSorted();
    this.updateBannerFlags();
    this.setLoadingLabor(false);
  }

  private endOfDay(d: Date) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
  }

  private daysUntil(date: any): number {
    if (!date) { return Number.NEGATIVE_INFINITY; }
    const end = this.endOfDay(new Date(date));
    const now = new Date();
    const diffMs = end.getTime() - now.getTime();
    return Math.ceil(diffMs / 86400000);
  }

  getCalculateStateDateContractEnd(date: any, _id?: any): string {
    if (!date) {
      return '';
    }

    const d = this.daysUntil(date);
    if (d < 0) { return 'DateRed'; }
    if (d >= 0 && d <= this.EXPIRY_WARNING_DAYS) { return 'DateOrange'; }
    return;
  }

  getCalculateStateStringContractEnd(date: any, _id?: any): string {
    if (!date) { return ''; }
    const d = this.daysUntil(date);
    if (d < 0) { return 'DateRed-string'; }
    if (d >= 0 && d <= this.EXPIRY_WARNING_DAYS) { return 'DateOrange-string'; }
    return;
  }

  getCalculateStateAndHourDescriptionContractEnd(date: any, _id?: any): string {
    if (!date) { return ''; }
    const d = this.daysUntil(date);
    if (d < 0) { return 'INACTIVO'; }
    if (d >= 0 && d <= this.EXPIRY_WARNING_DAYS) { return 'POR VENCER'; }
    return 'ACTIVO';
  }

  showEndDateBadge(date: any, _id?: any): boolean {
    if (!date) { return false; }
    const d = this.daysUntil(date);
    return d < 0 || (d >= 0 && d <= this.EXPIRY_WARNING_DAYS);
  }

  private isLaborInactive = (c: any): boolean => {
    if (!c) { return false; }
    if (c.IsActive === false) { return true; }
    if (typeof c.Status === 'string' && c.Status.toUpperCase() === 'INACTIVE') { return true; }
    if (c.EndDate) {
      const end = new Date(c.EndDate);
      if (!Number.isNaN(+end) && end < new Date()) { return true; }
    }
    return false;
  }

  private hasInactiveLaborContracts(): boolean {
    return (this.contractsLabor || []).some(this.isLaborInactive);
  }

  onShowAllFromInactiveBannerLabor(): void {
    if (!this.hasInactiveLaborContracts()) {
      this.snackBService.openWarning('NO HAY CONTRATOS INACTIVOS POR VER', '', 4000);
      this.showOnlyInactiveBanner = false;
      return;
    }
    this.showOnlyActiveLabor = false;
    this.showOnlyInactiveBanner = false;
    this.getPersonalEmployerInfoExit();
    this.rebuildVisibleLaborContractsSorted?.();
  }

  getScheduleText(): string {
    let contract: ContractsOffline;
    if (this.hasActiveContracts === true){
      contract = this.filterContracts[this.indexSelect];
    }else{
      contract = this.contracts[this.indexSelect];
    }
    return `Horario: ${contract.MinHour} ${contract.MaxHour}`;
  }

  setupTooltipBlackList(): string{
    return this.flagListFInfo?.Reason?.Description + ', ' + this.fechasService.getDateFormatRWith(this.flagListFInfo?.StartDate) +
      ', ' + (this.flagListFInfo?.User === null ? '' : this.flagListFInfo?.User?.Email);
  }

  setupTooltipVeto(): string{
    return (this.flagVetoInfo?.Reason === null ? '' : this.flagVetoInfo?.Reason?.Description) + ', ' +
      this.fechasService.getDateFormatRWith(this.flagVetoInfo?.StartDate) + ', ' +
      (this.flagVetoInfo?.User === null ? '' : this.flagVetoInfo?.User?.Email);
  }

  configDisabledDateCertification(certif?): boolean {
    if (this.flagListF || this.flagVeto) { return true; }

    const hasPermission = this.exitPermissionCompany('personalsrequirements.updatebyposition');
    const disabledByPermission = !hasPermission;
    const isEmployerRequirement = (certif?.Model ?? '').toLowerCase() === 'employerrequirement';

    return disabledByPermission || isEmployerRequirement;
  }

}
